// unbox
//
// Purpose: UnBox synth family preset categories
//
// This module:
// - Exports preset categories: UnBox Synth Pads through Novelty

import { toNameMap } from "../../../synth/synth-config";
import type { InputPresetCategory } from "./types";

export const unboxCategories: InputPresetCategory[] = [
	{
		name: "UnBox Synth Pads",
		presets: toNameMap([
			{
				name: "Filtered Pad",
				midiProgram: 89,
				tags: ["pwm", "unbox", "pad"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.25,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 105.11,
							linearGain: 0.25,
						},
					],
					effects: ["transition type", "note filter", "bitcrusher", "chorus", "reverb"],
					transition: "continue",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2.8284 }],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 14,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					pulseWidth: 50,
					decimalOffset: 0,
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "rise 3" }],
				},
			},
			{
				name: "Distorted Filter Pad",
				generalMidi: false,
				tags: ["pwm", "unbox", "pad"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 2 },
						{
							type: "high-pass",
							cutoffHz: 176.78,
							linearGain: 0.7071,
						},
					],
					effects: [
						"transition type",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "continue",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2.8284 }],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 2,
					bitcrusherQuantization: 14,
					panDelay: 10,
					chorus: 43,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					pulseWidth: 50,
					decimalOffset: 0,
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "rise 3" }],
				},
			},
			{
				name: "Smooth Pad",
				midiProgram: 91,
				tags: ["supersaw", "unbox", "pad"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 1 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 0.25,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 1 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 0.25,
						},
					],
					effects: ["bitcrusher", "chorus", "echo", "reverb"],
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 29,
					panDelay: 0,
					chorus: 29,
					echoSustain: 57,
					echoDelayBeats: 1.5,
					reverb: 45,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					pulseWidth: 18,
					decimalOffset: 0,
					dynamism: 83,
					spread: 42,
					shape: 50,
					envelopes: [],
				},
			},
			{
				name: "Filtered Smooth Pad",
				midiProgram: 93,
				tags: ["supersaw", "unbox", "pad"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 11313.71,
							linearGain: 0.3536,
						},
					],
					effects: [
						"transition type",
						"note filter",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "continue",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2.8284 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 29,
					echoSustain: 57,
					echoDelayBeats: 1.5,
					reverb: 45,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					pulseWidth: 18,
					decimalOffset: 0,
					dynamism: 83,
					spread: 42,
					shape: 50,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "rise 3" }],
				},
			},
			{
				name: "Shining Pad",
				midiProgram: 95,
				tags: ["fm", "fm4op", "unbox", "bellows"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 0.5,
						},
					],
					effects: ["transition type", "note filter", "chorus", "echo", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1.4142 }],
					panDelay: 10,
					chorus: 57,
					echoSustain: 57,
					echoDelayBeats: 0.5,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 7, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "swell 1" },
						{
							target: "noteFilterAllFreqs",
							envelope: "twang 3",
						},
					],
				},
			},
			{
				name: "Soft Pad",
				midiProgram: 90,
				tags: ["fm", "fm4op", "unbox", "pad"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 1,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 1,
						},
					],
					eqSubFilters1: [],
					effects: ["chorus", "echo", "reverb"],
					panDelay: 10,
					chorus: 86,
					echoSustain: 57,
					echoDelayBeats: 1.75,
					reverb: 58,
					fadeInSeconds: 0.075,
					fadeOutTicks: 24,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 10,
					operators: [
						{ frequency: "3×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "feedbackAmplitude", envelope: "swell 1" }],
				},
			},
			{
				name: "Triangle Pad",
				generalMidi: false,
				tags: ["chip", "chipwave", "unbox", "pad"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "high-pass", cutoffHz: 707.11, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 707.11, linearGain: 0.5 }],
					effects: ["transition type", "chord type", "detune", "bitcrusher", "echo"],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 1,
					detuneCents: 0,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					echoSustain: 43,
					echoDelayBeats: 1.75,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "triangle",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Zoid Pad",
				generalMidi: false,
				tags: ["chip", "chipwave", "unbox", "featured", "pad"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "chorus", "echo", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					panDelay: 10,
					chorus: 71,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "trapezoid",
					unison: "dirty",
					isUsingAdvancedLoopControls: true,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Pulse Pad",
				generalMidi: false,
				tags: ["pwm", "unbox", "pad"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 4,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 2.8284,
						},
					],
					effects: [
						"chord type",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 2,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 10376.27, linearGain: 1.4142 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 10376.27, linearGain: 1.4142 }],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 57,
					echoSustain: 71,
					echoDelayBeats: 1,
					reverb: 84,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 6,
					pulseWidth: 50,
					decimalOffset: 0,
					unison: "detune",
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "flare 2" },
						{
							target: "pulseWidth",
							envelope: "decay 1",
						},
						{ target: "noteFilterFreq", envelope: "tremolo3", index: 0 },
					],
				},
			},
			{
				name: "Ripped Pad",
				generalMidi: false,
				tags: ["chip", "chipwave", "unbox", "pad"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 1015.06, linearGain: 1.4142 }],
					eqFilterType: true,
					eqSimpleCut: 4,
					eqSimplePeak: 4,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["transition type", "distortion", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					distortion: 0,
					aliases: true,
					panDelay: 10,
					reverb: 58,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "hum",
					envelopes: [],
				},
			},
			{
				name: "Breath Pad",
				generalMidi: false,
				tags: ["supersaw", "unbox", "pad"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 0.7071,
						},
					],
					eqSubFilters1: [],
					effects: ["transition type", "reverb"],
					transition: "continue",
					clicklessTransition: false,
					panDelay: 10,
					reverb: 55,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					pulseWidth: 39,
					dynamism: 100,
					spread: 75,
					shape: 50,
					envelopes: [],
				},
			},
			{
				name: "Shiny",
				generalMidi: false,
				tags: ["chip", "chipwave", "unbox", "pad"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					chorus: 86,
					echoSustain: 43,
					echoDelayBeats: 1.5,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "Sync Buzzer Test",
					unison: "none",
					isUsingAdvancedLoopControls: true,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 64,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Pulsing Pad",
				generalMidi: false,
				tags: ["pwm", "unbox", "pad"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 8000,
							linearGain: 5.6569,
						},
						{ type: "peak", cutoffHz: 5656.85, linearGain: 4 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 13454.34, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 8000,
							linearGain: 5.6569,
						},
						{ type: "peak", cutoffHz: 5656.85, linearGain: 4 },
					],
					effects: ["note filter", "echo", "reverb"],
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 3828.43, linearGain: 0.5 }],
					panDelay: 10,
					echoSustain: 57,
					echoDelayBeats: 1.083,
					reverb: 3,
					fadeInSeconds: 0.0413,
					fadeOutTicks: 0,
					pulseWidth: 47,
					decimalOffset: 0,
					unison: "none",
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "wibble 1" },
						{
							target: "pulseWidth",
							envelope: "tremolo3",
						},
					],
				},
			},
		]),
	},
	{
		name: "UnBox Synth-Bass",
		presets: toNameMap([
			{
				name: "Bass Tone",
				midiProgram: 35,
				tags: ["fm", "fm4op", "unbox", "bass"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					eqSubFilters1: [],
					effects: ["detune", "bitcrusher", "reverb"],
					detuneCents: 0,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "punch", index: 3 },
						{
							target: "feedbackAmplitude",
							envelope: "decay 2",
						},
						{ target: "operatorAmplitude", envelope: "twang 3", index: 1 },
					],
				},
			},
			{
				name: "Bass Sub",
				midiProgram: 34,
				tags: ["fm", "fm4op", "unbox", "bass"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["transition type", "detune", "bitcrusher"],
					transition: "normal",
					clicklessTransition: true,
					detuneCents: 0,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteVolume", envelope: "note size" }],
				},
			},
			{
				name: "Bass Tone Scream",
				midiProgram: 35,
				tags: ["fm", "fm4op", "unbox", "bass"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					eqSubFilters1: [],
					effects: ["detune", "bitcrusher", "reverb"],
					detuneCents: 0,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 71,
					panDelay: 10,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←2←(3 4)",
					feedbackType: "1→2→3→4",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 3, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "punch", index: 3 },
						{
							target: "feedbackAmplitude",
							envelope: "decay 2",
						},
						{ target: "operatorAmplitude", envelope: "twang 3", index: 1 },
					],
				},
			},
			{
				name: "Smooth Bass Sub",
				midiProgram: 34,
				tags: ["fm", "fm4op", "unbox", "bass"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["transition type", "detune", "bitcrusher"],
					transition: "normal",
					clicklessTransition: true,
					detuneCents: 0,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←3 2←4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteVolume", envelope: "note size" }],
				},
			},
			{
				name: "Triangle Bass Sub",
				midiProgram: 34,
				tags: ["fm", "fm4op", "unbox", "bass"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["detune"],
					detuneCents: 0,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Bass Tone Crunch",
				midiProgram: 37,
				tags: ["fm", "fm4op", "unbox", "bass"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					eqSubFilters1: [],
					effects: ["detune", "bitcrusher", "reverb"],
					detuneCents: 0,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 100,
					panDelay: 10,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "1→2→3→4→1",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 2, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 3, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "punch", index: 3 },
						{
							target: "feedbackAmplitude",
							envelope: "decay 2",
						},
						{ target: "operatorAmplitude", envelope: "twang 3", index: 1 },
					],
				},
			},
			{
				name: "Bass Tone Distortion",
				midiProgram: 33,
				tags: ["fm", "fm4op", "unbox", "bass"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["transition type", "detune", "distortion", "bitcrusher"],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: 0,
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 57,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←3 2←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 10,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "feedbackAmplitude", envelope: "decay 2" },
						{
							target: "operatorAmplitude",
							envelope: "twang 3",
							index: 1,
						},
						{ target: "noteVolume", envelope: "punch" },
					],
				},
			},
			{
				name: "Thick Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "bass"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.3536,
						},
						{ type: "peak", cutoffHz: 1000, linearGain: 0.7071 },
					],
					effects: [
						"transition type",
						"detune",
						"vibrato",
						"note filter",
						"chorus",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: 0,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 0,
					vibratoSpeed: 3,
					vibratoType: 1,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 3222.02, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 3222.02, linearGain: 1 }],
					panDelay: 10,
					chorus: 0,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 8,
					operators: [
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 11, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "13×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "punch" },
						{ target: "operatorAmplitude", envelope: "twang 2", index: 1 },
						{ target: "operatorAmplitude", envelope: "twang 3", index: 2 },
						{ target: "operatorAmplitude", envelope: "twang 2", index: 3 },
						{ target: "noteVolume", envelope: "twang 3" },
					],
				},
			},
			{
				name: "Thick Bass Sub",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "bass"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 500, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 500, linearGain: 1 }],
					effects: [],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "operatorAmplitude", envelope: "twang 2", index: 1 }],
				},
			},
			{
				name: "Filtered Saw Bass",
				midiProgram: 39,
				tags: ["chip", "chipwave", "unbox", "bass"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 4,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["note filter", "distortion", "bitcrusher"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 420.45,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.0884 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 420.45,
							linearGain: 2.8284,
						},
						{ type: "peak", cutoffHz: 5656.85, linearGain: 0.0884 },
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					distortion: 57,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 0,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "sawtooth",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{ target: "noteFilterFreq", envelope: "decay 3", index: 0 },
						{
							target: "noteFilterFreq",
							envelope: "decay 3",
							index: 1,
						},
					],
				},
			},
			{
				name: "Acid Saw Bass",
				midiProgram: 39,
				tags: ["fm", "fm4op", "unbox", "bass"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					effects: ["transition type", "note filter"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 11.3137,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 11.3137,
						},
					],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1←3 2←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 2" }],
				},
			},
			{
				name: "Acid Tri Bass",
				midiProgram: 39,
				tags: ["fm", "fm4op", "unbox", "bass"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					effects: ["transition type", "note filter"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 11.3137,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 11.3137,
						},
					],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1←3 2←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 2" }],
				},
			},
			{
				name: "Acid Square Bass",
				midiProgram: 39,
				tags: ["fm", "fm4op", "unbox", "bass"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					effects: ["transition type", "note filter"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 11.3137,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 11.3137,
						},
					],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1←3 2←4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 2" }],
				},
			},
			{
				name: "Acid Pulse Bass",
				midiProgram: 39,
				tags: ["pwm", "unbox", "bass"],
				settings: {
					type: "PWM",
					eqFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					effects: ["transition type", "note filter"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 11.3137,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 11.3137,
						},
					],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					pulseWidth: 50,
					decimalOffset: 0,
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 2" }],
				},
			},
			{
				name: "Acid SuperSaw Bass",
				midiProgram: 39,
				tags: ["supersaw", "unbox", "bass"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					effects: ["transition type", "note filter"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 11.3137,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 11.3137,
						},
					],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					pulseWidth: 49,
					decimalOffset: 0,
					dynamism: 100,
					spread: 50,
					shape: 0,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 2" }],
				},
			},
			{
				name: "Squash Bass",
				generalMidi: false,
				tags: ["chip", "customchip", "unbox", "chiptune", "bass", "retro"],
				settings: {
					type: "custom chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					effects: ["transition type", "bitcrusher"],
					transition: "interrupt",
					clicklessTransition: false,
					bitcrusherOctave: 1,
					bitcrusherQuantization: 29,
					panDelay: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					customChipWave: {
						"0": -1,
						"1": -1,
						"2": -4,
						"3": -4,
						"4": -8,
						"5": -8,
						"6": -11,
						"7": -11,
						"8": -14,
						"9": -14,
						"10": -17,
						"11": -17,
						"12": -20,
						"13": -20,
						"14": -24,
						"15": -24,
						"16": -24,
						"17": -24,
						"18": -24,
						"19": -24,
						"20": -23,
						"21": -24,
						"22": -24,
						"23": -24,
						"24": -23,
						"25": -21,
						"26": -19,
						"27": -15,
						"28": -9,
						"29": -2,
						"30": 2,
						"31": 6,
						"32": 10,
						"33": 13,
						"34": 14,
						"35": 16,
						"36": 17,
						"37": 18,
						"38": 19,
						"39": 20,
						"40": 21,
						"41": 21,
						"42": 22,
						"43": 23,
						"44": 24,
						"45": 24,
						"46": 24,
						"47": 24,
						"48": 24,
						"49": 24,
						"50": 21,
						"51": 21,
						"52": 18,
						"53": 18,
						"54": 15,
						"55": 15,
						"56": 12,
						"57": 12,
						"58": 8,
						"59": 8,
						"60": 5,
						"61": 5,
						"62": 2,
						"63": 2,
					},
					customChipWaveIntegral: {
						"0": 0,
						"1": 0,
						"2": 0,
						"3": 0,
						"4": 0,
						"5": 0,
						"6": 0,
						"7": 0,
						"8": 0,
						"9": 0,
						"10": 0,
						"11": 0,
						"12": 0,
						"13": 0,
						"14": 0,
						"15": 0,
						"16": 0,
						"17": 0,
						"18": 0,
						"19": 0,
						"20": 0,
						"21": 0,
						"22": 0,
						"23": 0,
						"24": 0,
						"25": 0,
						"26": 0,
						"27": 0,
						"28": 0,
						"29": 0,
						"30": 0,
						"31": 0,
						"32": 0,
						"33": 0,
						"34": 0,
						"35": 0,
						"36": 0,
						"37": 0,
						"38": 0,
						"39": 0,
						"40": 0,
						"41": 0,
						"42": 0,
						"43": 0,
						"44": 0,
						"45": 0,
						"46": 0,
						"47": 0,
						"48": 0,
						"49": 0,
						"50": 0,
						"51": 0,
						"52": 0,
						"53": 0,
						"54": 0,
						"55": 0,
						"56": 0,
						"57": 0,
						"58": 0,
						"59": 0,
						"60": 0,
						"61": 0,
						"62": 0,
						"63": 0,
						"64": 0,
					},
					envelopes: [
						{
							target: "noteVolume",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Pulse-Del Bass 1",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "bass", "retro"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 210.22,
							linearGain: 0.1768,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 210.22,
							linearGain: 0.1768,
						},
					],
					effects: ["transition type", "note filter", "bitcrusher", "chorus"],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 74.33,
							linearGain: 0.0884,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 74.33,
							linearGain: 0.0884,
						},
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					noteSubFilters2: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 74.33,
							linearGain: 0.0884,
						},
					],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 14,
					fadeInSeconds: 0,
					fadeOutTicks: 72,
					algorithm: "1←3 2←4",
					feedbackType: "1→4 2→3",
					feedbackAmplitude: 14,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "pulse width", pulseWidth: 2 },
						{ frequency: "1×", amplitude: 13, waveform: "pulse width", pulseWidth: 8 },
						{ frequency: "4×", amplitude: 8, waveform: "pulse width", pulseWidth: 7 },
						{ frequency: "8×", amplitude: 11, waveform: "pulse width", pulseWidth: 6 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "noteFilterFreq",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "Pulse-Del Bass 2",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "bass", "retro"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 210.22,
							linearGain: 0.1768,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 210.22,
							linearGain: 0.1768,
						},
					],
					effects: ["transition type", "note filter", "bitcrusher", "chorus"],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 74.33,
							linearGain: 0.0884,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 2.8284 },
						{
							type: "peak",
							cutoffHz: 74.33,
							linearGain: 0.0884,
						},
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					noteSubFilters2: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 74.33,
							linearGain: 0.0884,
						},
					],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 14,
					fadeInSeconds: 0,
					fadeOutTicks: 72,
					algorithm: "1←3 2←4",
					feedbackType: "1→4 2→3",
					feedbackAmplitude: 14,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "pulse width", pulseWidth: 2 },
						{ frequency: "1×", amplitude: 13, waveform: "pulse width", pulseWidth: 8 },
						{ frequency: "4×", amplitude: 8, waveform: "pulse width", pulseWidth: 7 },
						{ frequency: "8×", amplitude: 11, waveform: "pulse width", pulseWidth: 6 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "noteFilterFreq",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "Soft Pulse-Del Bass 1",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "bass", "retro"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 210.22,
							linearGain: 0.1768,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 210.22,
							linearGain: 0.1768,
						},
					],
					effects: ["transition type", "note filter", "bitcrusher", "chorus"],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 297.3, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 74.33,
							linearGain: 0.0884,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 297.3, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 74.33,
							linearGain: 0.0884,
						},
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					noteSubFilters2: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 74.33,
							linearGain: 0.0884,
						},
					],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 14,
					fadeInSeconds: 0,
					fadeOutTicks: 72,
					algorithm: "1←3 2←4",
					feedbackType: "1→4 2→3",
					feedbackAmplitude: 14,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "pulse width", pulseWidth: 2 },
						{ frequency: "1×", amplitude: 13, waveform: "pulse width", pulseWidth: 8 },
						{ frequency: "4×", amplitude: 8, waveform: "pulse width", pulseWidth: 7 },
						{ frequency: "8×", amplitude: 11, waveform: "pulse width", pulseWidth: 6 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "noteFilterFreq",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
			{
				name: "Soft Pulse-Del Bass 2",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "bass", "retro"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 210.22,
							linearGain: 0.1768,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 210.22,
							linearGain: 0.1768,
						},
					],
					effects: ["transition type", "note filter", "bitcrusher", "chorus"],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 297.3, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 74.33,
							linearGain: 0.0884,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 297.3, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 74.33,
							linearGain: 0.0884,
						},
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1 }],
					noteSubFilters2: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 74.33,
							linearGain: 0.0884,
						},
					],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 14,
					fadeInSeconds: 0,
					fadeOutTicks: 72,
					algorithm: "1←3 2←4",
					feedbackType: "1→4 2→3",
					feedbackAmplitude: 14,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "pulse width", pulseWidth: 2 },
						{ frequency: "1×", amplitude: 13, waveform: "pulse width", pulseWidth: 8 },
						{ frequency: "4×", amplitude: 8, waveform: "pulse width", pulseWidth: 7 },
						{ frequency: "8×", amplitude: 11, waveform: "pulse width", pulseWidth: 7 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "noteFilterFreq",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
					],
				},
			},
		]),
	},
	{
		name: "UnBox Synth-Brass",
		presets: toNameMap([
			{
				name: "Synth Brass 1",
				midiProgram: 63,
				tags: ["fm", "fm4op", "unbox", "brass"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 4756.83,
							linearGain: 5.6569,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 4756.83,
							linearGain: 5.6569,
						},
					],
					effects: [
						"transition type",
						"chord type",
						"note filter",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					chord: "custom interval",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					panDelay: 10,
					chorus: 57,
					echoSustain: 43,
					echoDelayBeats: 0.583,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "swell 1" },
						{
							target: "noteFilterAllFreqs",
							envelope: "twang 3",
						},
					],
				},
			},
			{
				name: "Synth Brass 2",
				midiProgram: 64,
				tags: ["fm", "fm4op", "unbox", "brass"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 4756.83,
							linearGain: 5.6569,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 4756.83,
							linearGain: 5.6569,
						},
					],
					effects: [
						"transition type",
						"chord type",
						"note filter",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					chord: "custom interval",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					panDelay: 10,
					chorus: 57,
					echoSustain: 43,
					echoDelayBeats: 0.583,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "flare 2" },
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
						},
					],
				},
			},
			{
				name: "Synth Muted Trumpet",
				midiProgram: 57,
				tags: ["fm", "fm4op", "unbox", "brass"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 4756.83,
							linearGain: 5.6569,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 4756.83,
							linearGain: 5.6569,
						},
					],
					effects: ["transition type", "note filter", "chorus", "echo", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					panDelay: 10,
					chorus: 57,
					echoSustain: 43,
					echoDelayBeats: 0.5,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2←(3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "swell 1" },
						{
							target: "noteFilterAllFreqs",
							envelope: "twang 3",
						},
					],
				},
			},
			{
				name: "Synth Trumpet",
				midiProgram: 60,
				tags: ["fm", "fm4op", "unbox", "brass"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.7071,
						},
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.7071,
						},
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2 },
					],
					effects: ["transition type", "note filter", "chorus", "echo", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1.4142 }],
					panDelay: 10,
					chorus: 43,
					echoSustain: 29,
					echoDelayBeats: 0.5,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1 2←(3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "note size" },
						{
							target: "noteFilterAllFreqs",
							envelope: "twang 3",
						},
					],
				},
			},
			{
				name: "Synth Trombone 1",
				midiProgram: 58,
				tags: ["fm", "fm4op", "unbox", "brass"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["chorus", "reverb"],
					panDelay: 10,
					chorus: 57,
					reverb: 74,
					fadeInSeconds: 0.0263,
					fadeOutTicks: -3,
					algorithm: "1←3 2←4",
					feedbackType: "2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Synth Trombone 2",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "brass"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "high-pass", cutoffHz: 500, linearGain: 0.0884 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 500, linearGain: 0.0884 }],
					effects: ["chorus", "reverb"],
					panDelay: 10,
					chorus: 57,
					reverb: 74,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -3,
					algorithm: "1←3 2←4",
					feedbackType: "2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Synth Horn",
				midiProgram: 61,
				tags: ["fm", "fm4op", "unbox", "brass"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 2 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 2 }],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1.4142 }],
					panDelay: 0,
					reverb: 32,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 6,
					algorithm: "1 2 3 4",
					feedbackType: "2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 4, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Synth Brass Slide",
				midiProgram: 63,
				tags: ["fm", "fm4op", "unbox", "brass"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.7071,
						},
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.7071,
						},
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2 },
					],
					effects: [
						"transition type",
						"chord type",
						"note filter",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					chord: "custom interval",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1.4142 }],
					panDelay: 10,
					chorus: 57,
					echoSustain: 71,
					echoDelayBeats: 0.75,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "flare 2" },
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
						},
					],
				},
			},
			{
				name: "Synth Soft Brass",
				generalMidi: false,
				tags: ["fm", "fm6op", "unbox", "brass"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "high-pass", cutoffHz: 148.65, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 148.65, linearGain: 1 }],
					effects: ["transition type", "chord type", "pitch shift", "distortion"],
					transition: "normal",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 12,
					distortion: 0,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					algorithm: "1←3 2←(4 5)←6",
					feedbackType: "Custom",
					feedbackAmplitude: 9,
					customFeedback: { mods: [[1], [4], [], [], [], []] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 1, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteVolume", envelope: "twang 3" }],
				},
			},
		]),
	},
	{
		name: "UnBox Synth-Keys",
		presets: toNameMap([
			{
				name: "Triangle Keys",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "keys"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.7071,
						},
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.7071,
						},
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 2 },
					],
					effects: ["transition type", "note filter", "chorus", "echo", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1.4142 }],
					panDelay: 10,
					chorus: 57,
					echoSustain: 43,
					echoDelayBeats: 0.5,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 10,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 7, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 11, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "note size" },
						{
							target: "noteFilterAllFreqs",
							envelope: "twang 3",
						},
					],
				},
			},
			{
				name: "Fuzzy Keys",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "keys"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 4756.83, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 4756.83, linearGain: 11.3137 },
					],
					effects: [
						"transition type",
						"chord type",
						"note filter",
						"bitcrusher",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.3536 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 0.5,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.3536 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 0.5,
						},
					],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 43,
					panDelay: 10,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						100, 71, 71, 0, 0, 14, 71, 43, 43, 71, 29, 43, 43, 29, 43, 71, 14, 14, 43,
						43, 43, 0, 14, 14, 14, 43, 29, 29,
					],
					unison: "dirty",
					stringSustain: 64,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "swell 2" }],
				},
			},
			{
				name: "Soft Keys",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "keys"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 2 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 2 }],
					effects: ["transition type", "note filter", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1.4142 }],
					panDelay: 10,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "flare 1" }],
				},
			},
			{
				name: "Distressed Keys",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "keys"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 4756.83, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 125,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 4756.83, linearGain: 11.3137 },
					],
					effects: ["chord type", "detune", "note filter", "bitcrusher"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: 32,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.25 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.25 }],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 43,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						100, 71, 71, 0, 0, 14, 71, 43, 43, 57, 29, 43, 43, 29, 57, 71, 14, 14, 43,
						43, 43, 0, 14, 14, 14, 29, 14, 14,
					],
					unison: "dirty",
					stringSustain: 71,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "swell 2" }],
				},
			},
			{
				name: "Thin Keys",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "keys"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.25,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.25,
						},
					],
					effects: [
						"transition type",
						"chord type",
						"vibrato",
						"note filter",
						"bitcrusher",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 }],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					echoSustain: 29,
					echoDelayBeats: 0.5,
					reverb: 52,
					fadeInSeconds: 0.1575,
					fadeOutTicks: -1,
					harmonics: [
						14, 71, 71, 86, 0, 100, 71, 0, 0, 71, 43, 0, 43, 0, 100, 100, 71, 0, 86, 86,
						100, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "dirty",
					stringSustain: 93,
					envelopes: [],
				},
			},
			{
				name: "Garbled Keys",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "keys"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.25,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.25,
						},
					],
					effects: [
						"transition type",
						"chord type",
						"vibrato",
						"note filter",
						"bitcrusher",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 }],
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					echoSustain: 29,
					echoDelayBeats: 2,
					reverb: 61,
					fadeInSeconds: 0.1575,
					fadeOutTicks: -1,
					harmonics: [
						14, 71, 71, 86, 0, 100, 71, 0, 0, 71, 43, 0, 43, 0, 100, 100, 71, 0, 86, 86,
						100, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "dirty",
					stringSustain: 93,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "wibble-1" }],
				},
			},
			{
				name: "Lone Keys Pulse",
				midiProgram: 81,
				tags: ["chip", "chipwave", "unbox", "keys"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 24,
					detuneCents: 4,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 26,
					vibratoSpeed: 1,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 71,
					echoSustain: 57,
					echoDelayBeats: 2,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					wave: "square",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 2" }],
				},
			},
			{
				name: "Lone Keys Saw",
				midiProgram: 82,
				tags: ["chip", "chipwave", "unbox", "keys"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 24,
					detuneCents: 4,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 26,
					vibratoSpeed: 1,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 71,
					echoSustain: 57,
					echoDelayBeats: 2,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					wave: "sawtooth",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 2" }],
				},
			},
			{
				name: "Lone Keys Triangle",
				midiProgram: 71,
				tags: ["chip", "chipwave", "unbox", "keys"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 24,
					detuneCents: 4,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 26,
					vibratoSpeed: 1,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 71,
					echoSustain: 57,
					echoDelayBeats: 2,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					wave: "triangle",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 2" }],
				},
			},
			{
				name: "Distant Key",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "keys"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 1.4142 },
						{
							type: "low-pass",
							cutoffHz: 594.6,
							linearGain: 0.1768,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 1.4142 },
						{
							type: "low-pass",
							cutoffHz: 594.6,
							linearGain: 0.1768,
						},
					],
					effects: [
						"transition type",
						"detune",
						"note filter",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "continue",
					clicklessTransition: false,
					detuneCents: 6,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 5656.85, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.125 },
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.25 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 5656.85, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.125 },
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.25 },
					],
					panDelay: 20,
					chorus: 29,
					echoSustain: 100,
					echoDelayBeats: 2,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Lost Memories",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "keys"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 1414.21,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 1414.21,
							linearGain: 0.5,
						},
					],
					effects: [
						"transition type",
						"detune",
						"note filter",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "continue",
					clicklessTransition: false,
					detuneCents: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 5656.85, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.125 },
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.25 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 5656.85, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.125 },
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.25 },
						{ type: "peak", cutoffHz: 297.3, linearGain: 0.25 },
					],
					panDelay: 20,
					chorus: 29,
					echoSustain: 100,
					echoDelayBeats: 1,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Tape Organ",
				generalMidi: false,
				tags: ["harmonics", "unbox", "bellows"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 62.5,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 8000, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 62.5,
							linearGain: 0.5,
						},
						{ type: "peak", cutoffHz: 8000, linearGain: 1.4142 },
					],
					effects: ["transition type", "vibrato", "note filter", "bitcrusher", "chorus"],
					transition: "normal",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 1,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0.1138,
					fadeOutTicks: 48,
					harmonics: [
						100, 71, 43, 57, 0, 29, 0, 43, 0, 0, 0, 43, 0, 0, 0, 29, 0, 0, 0, 0, 0, 0,
						0, 29, 0, 0, 0, 14,
					],
					unison: "fluctuate",
					envelopes: [],
				},
			},
		]),
	},
	{
		name: "UnBox Mix-Synth",
		presets: toNameMap([
			// May be moved to more sutable locations.
			{
				name: "Far Echo Pad",
				midiProgram: 93,
				tags: ["pwm", "unbox", "pad"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 2.8284,
						},
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 2,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 2.8284,
						},
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 },
					],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 4,
					pitchShiftSemitones: 36,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 10376.27, linearGain: 1.4142 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 10376.27, linearGain: 1.4142 }],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 57,
					echoSustain: 71,
					echoDelayBeats: 1,
					reverb: 84,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 6,
					pulseWidth: 100,
					decimalOffset: 0,
					unison: "detune",
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "flare 2" },
						{
							target: "pulseWidth",
							envelope: "flutter 2",
						},
						{ target: "noteFilterFreq", envelope: "tremolo3", index: 0 },
					],
				},
			},
			{
				name: "Echo Pad",
				midiProgram: 93,
				tags: ["pwm", "unbox", "pad"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 2.8284,
						},
					],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 2,
					pitchShiftSemitones: 36,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 10376.27, linearGain: 1.4142 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 10376.27, linearGain: 1.4142 }],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 57,
					echoSustain: 71,
					echoDelayBeats: 1,
					reverb: 81,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					pulseWidth: 100,
					decimalOffset: 0,
					unison: "detune",
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "flare 2" },
						{
							target: "pulseWidth",
							envelope: "decay 3",
						},
						{ target: "noteFilterFreq", envelope: "tremolo3", index: 0 },
					],
				},
			},
			{
				name: "Echo Pulse Pad",
				midiProgram: 93,
				tags: ["pwm", "unbox", "pad"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 4,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 2.8284,
						},
					],
					effects: [
						"transition type",
						"chord type",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 2,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 10376.27, linearGain: 1.4142 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 10376.27, linearGain: 1.4142 }],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 57,
					echoSustain: 71,
					echoDelayBeats: 1,
					reverb: 81,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 100,
					decimalOffset: 0,
					unison: "detune",
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "flare 2" },
						{
							target: "pulseWidth",
							envelope: "water-y flutter",
						},
						{ target: "noteFilterFreq", envelope: "tremolo3", index: 0 },
					],
				},
			},
			{
				name: "Echo Pulse Synth",
				midiProgram: 93,
				tags: ["pwm", "unbox"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 4,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 2.8284,
						},
					],
					effects: [
						"transition type",
						"chord type",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 2,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 10376.27, linearGain: 1.4142 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 10376.27, linearGain: 1.4142 }],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 57,
					echoSustain: 71,
					echoDelayBeats: 1,
					reverb: 81,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 100,
					decimalOffset: 0,
					unison: "detune",
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "flare 2" },
						{
							target: "pulseWidth",
							envelope: "wibble 3",
						},
						{ target: "noteFilterFreq", envelope: "tremolo3", index: 0 },
					],
				},
			},
			{
				name: "Echo Shimmer",
				midiProgram: 93,
				tags: ["pwm", "unbox"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 2.8284,
						},
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 2,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 707.11,
							linearGain: 2.8284,
						},
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 },
					],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 36,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 10376.27, linearGain: 1.4142 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 10376.27, linearGain: 1.4142 }],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 57,
					echoSustain: 71,
					echoDelayBeats: 1,
					reverb: 81,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 50,
					decimalOffset: 0,
					unison: "detune",
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "flare 2" },
						{
							target: "pulseWidth",
							envelope: "flutter 1",
						},
						{ target: "noteFilterFreq", envelope: "tremolo3", index: 0 },
					],
				},
			},
			{
				name: "Shimmer Keys",
				midiProgram: 94,
				tags: ["fm", "fm4op", "unbox", "keys"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "high-pass", cutoffHz: 250, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 250, linearGain: 0.7071 }],
					effects: ["transition type", "chorus", "echo", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					panDelay: 10,
					chorus: 43,
					echoSustain: 43,
					echoDelayBeats: 0.583,
					reverb: 45,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 12,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 10, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteVolume", envelope: "twang 2" }],
				},
			},
			{
				name: "Wispy Pad",
				midiProgram: 94,
				tags: ["fm", "fm4op", "unbox", "pad"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 4756.83,
							linearGain: 5.6569,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 707.11, linearGain: 0.25 },
						{
							type: "peak",
							cutoffHz: 4756.83,
							linearGain: 5.6569,
						},
					],
					effects: ["transition type", "note filter", "chorus", "echo"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					panDelay: 10,
					chorus: 57,
					echoSustain: 43,
					echoDelayBeats: 0.583,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 15,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "swell 1" },
						{
							target: "noteFilterAllFreqs",
							envelope: "twang 3",
						},
					],
				},
			},
			{
				name: "Shimmer Pad",
				midiProgram: 94,
				tags: ["supersaw", "unbox", "pad"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.3536 }],
					effects: ["transition type", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					panDelay: 10,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					pulseWidth: 99,
					decimalOffset: 0,
					dynamism: 83,
					spread: 50,
					shape: 50,
					envelopes: [],
				},
			},
			{
				name: "Dark",
				generalMidi: false,
				tags: ["fm", "fm6op", "unbox"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 2500, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 6,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["note filter", "echo", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.7071 }],
					panDelay: 10,
					echoSustain: 0,
					echoDelayBeats: 1,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "(1 2)←4 3←(5 6)",
					feedbackType: "1↔2 3↔4 5↔6",
					feedbackAmplitude: 7,
					operators: [
						{
							frequency: "0.75×",
							amplitude: 14,
							waveform: "pulse width",
							pulseWidth: 4,
						},
						{ frequency: "3×", amplitude: 14, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 7, waveform: "triangle", pulseWidth: 5 },
						{
							frequency: "0.75×",
							amplitude: 8,
							waveform: "pulse width",
							pulseWidth: 6,
						},
						{ frequency: "13×", amplitude: 0, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "50×", amplitude: 0, waveform: "sawtooth", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
					],
				},
			},
			{
				name: "Saw String",
				generalMidi: false,
				tags: ["chip", "chipwave", "unbox", "string"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 }],
					effects: [
						"transition type",
						"vibrato",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 4,
					vibratoSpeed: 8,
					vibratoType: 0,
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					chorus: 29,
					reverb: 65,
					fadeInSeconds: 0.1575,
					fadeOutTicks: 6,
					wave: "YM2149f Hard Buzzer ⧵",
					unison: "dirty",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "String Buzzer",
				generalMidi: false,
				tags: ["chip", "chipwave", "unbox", "string"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 }],
					effects: [
						"transition type",
						"vibrato",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 4,
					vibratoSpeed: 8,
					vibratoType: 0,
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					chorus: 29,
					reverb: 65,
					fadeInSeconds: 0.1575,
					fadeOutTicks: 6,
					wave: "YM2149f Soft Buzzer Λ",
					unison: "dirty",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 64,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
		]),
	},
	{
		name: "UnBox Synth-Atmos",
		presets: toNameMap([
			{
				name: "Tape Crackle",
				midiProgram: 83,
				tags: ["spectrum", "unbox"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "peak", cutoffHz: 250, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "peak", cutoffHz: 250, linearGain: 0.5 }],
					effects: [
						"chord type",
						"pitch shift",
						"detune",
						"note filter",
						"distortion",
						"bitcrusher",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 24,
					detuneCents: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 1 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 0.7071,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 1 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 0.7071,
						},
					],
					distortion: 0,
					aliases: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					spectrum: [
						100, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 57, 0, 0, 57, 0, 43, 0, 43, 0, 0, 29, 0,
						29, 0, 14, 14, 14, 0, 0,
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Tape Synth",
				midiProgram: 83,
				tags: ["spectrum", "unbox"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "detune", "note filter", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: -2,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.7071,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.7071,
						},
					],
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					spectrum: [
						100, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 0, 0, 0, 57, 0, 43, 0, 43, 0, 0, 29, 0,
						29, 0, 14, 14, 14, 0, 0,
					],
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "swell 1" }],
				},
			},
			{
				name: "Tape Distortion",
				midiProgram: 83,
				tags: ["spectrum", "unbox", "distortion"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "detune", "note filter", "bitcrusher", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: 2,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.7071,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.7071,
						},
					],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 0,
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					spectrum: [
						100, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 0, 0, 0, 57, 0, 43, 0, 43, 0, 0, 29, 0,
						29, 0, 14, 14, 14, 0, 0,
					],
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "swell 1" }],
				},
			},
			{
				name: "Shine Shine",
				midiProgram: 83,
				tags: ["spectrum", "unbox"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "peak", cutoffHz: 250, linearGain: 0.5 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "peak", cutoffHz: 250, linearGain: 0.5 }],
					effects: [
						"transition type",
						"chord type",
						"detune",
						"note filter",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: 2,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 1 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 0.7071,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 1 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 0.7071,
						},
					],
					bitcrusherOctave: 5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 14,
					echoSustain: 71,
					echoDelayBeats: 0.917,
					reverb: 16,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					spectrum: [
						100, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 57, 0, 0, 57, 0, 43, 0, 43, 0, 0, 29, 0,
						29, 0, 14, 14, 14, 14, 0,
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Soft Atmos",
				midiProgram: 95,
				tags: ["spectrum", "unbox", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"chord type",
						"detune",
						"note filter",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 2,
					detuneCents: 2,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.3536,
						},
						{ type: "high-pass", cutoffHz: 500, linearGain: 1 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.3536,
						},
						{ type: "high-pass", cutoffHz: 500, linearGain: 1 },
					],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 29,
					echoSustain: 71,
					echoDelayBeats: 0.917,
					reverb: 16,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					spectrum: [
						100, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 57, 0, 0, 57, 0, 43, 0, 43, 0, 0, 29, 0,
						29, 0, 14, 14, 14, 14, 43,
					],
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "rise -2" }],
				},
			},
			{
				name: "Hard Atmos",
				midiProgram: 95,
				tags: ["spectrum", "unbox", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 0.7071,
						},
					],
					effects: [
						"transition type",
						"chord type",
						"detune",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 2,
					detuneCents: 2,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.3536,
						},
						{ type: "high-pass", cutoffHz: 500, linearGain: 1 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.3536,
						},
						{ type: "high-pass", cutoffHz: 500, linearGain: 1 },
					],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 71,
					panDelay: 10,
					chorus: 29,
					echoSustain: 71,
					echoDelayBeats: 0.917,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					spectrum: [
						100, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 57, 0, 0, 57, 0, 43, 0, 43, 0, 0, 29, 0,
						29, 0, 14, 14, 14, 14, 43,
					],
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "rise -2" }],
				},
			},
			{
				name: "Atmos Woosh",
				midiProgram: 103,
				tags: ["spectrum", "unbox", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "high-pass", cutoffHz: 707.11, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 707.11, linearGain: 0.7071 }],
					effects: ["transition type", "bitcrusher", "echo", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 2,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					spectrum: [
						100, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 57, 0, 0, 71, 0, 0, 86, 0, 100, 0, 43,
						0, 0, 71, 14, 43, 0, 71, 0,
					],
					unison: "none",
					envelopes: [{ target: "noteVolume", envelope: "tremolo0" }],
				},
			},
			{
				name: "Distorted Woosh",
				midiProgram: 103,
				tags: ["spectrum", "unbox", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "high-pass", cutoffHz: 707.11, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 707.11, linearGain: 0.7071 }],
					effects: ["transition type", "bitcrusher", "echo", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 0,
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 2,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					spectrum: [
						100, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 57, 0, 0, 71, 0, 0, 86, 0, 100, 0, 43,
						0, 0, 71, 14, 43, 0, 71, 0,
					],
					unison: "none",
					envelopes: [{ target: "noteVolume", envelope: "tremolo0" }],
				},
			},
			{
				name: "Creak",
				midiProgram: 100,
				tags: ["spectrum", "unbox", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.7071,
						},
					],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: true,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 24,
					detuneCents: -16,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.3536,
						},
						{ type: "high-pass", cutoffHz: 500, linearGain: 1 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.3536,
						},
						{ type: "high-pass", cutoffHz: 500, linearGain: 1 },
					],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 3,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 57,
					echoSustain: 100,
					echoDelayBeats: 1.333,
					reverb: 87,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					spectrum: [
						100, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 57, 0, 0, 57, 0, 43, 0, 43, 0, 0, 29, 0,
						29, 0, 14, 14, 14, 0, 43,
					],
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "rise -2" }],
				},
			},
			{
				name: "Creak Arp",
				midiProgram: 100,
				tags: ["spectrum", "unbox", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.7071,
						},
					],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: true,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 24,
					detuneCents: -16,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.3536,
						},
						{ type: "high-pass", cutoffHz: 500, linearGain: 1 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.3536,
						},
						{ type: "high-pass", cutoffHz: 500, linearGain: 1 },
					],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 3,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 57,
					echoSustain: 100,
					echoDelayBeats: 1.333,
					reverb: 87,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					spectrum: [
						100, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 57, 0, 0, 57, 0, 43, 0, 43, 0, 0, 29, 0,
						29, 0, 14, 14, 14, 0, 43,
					],
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "rise -2" }],
				},
			},
			{
				name: "Deep Atmos",
				midiProgram: 100,
				tags: ["spectrum", "unbox", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.7071,
						},
					],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: true,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 12,
					detuneCents: -16,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.3536,
						},
						{ type: "high-pass", cutoffHz: 500, linearGain: 1 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.3536,
						},
						{ type: "high-pass", cutoffHz: 500, linearGain: 1 },
					],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 1.5,
					bitcrusherQuantization: 57,
					panDelay: 10,
					chorus: 57,
					echoSustain: 100,
					echoDelayBeats: 1.333,
					reverb: 87,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					spectrum: [
						100, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 57, 0, 0, 57, 0, 43, 0, 43, 0, 0, 29, 0,
						29, 0, 14, 14, 14, 0, 43,
					],
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "rise -2" }],
				},
			},
			{
				name: "Deep Arp",
				midiProgram: 100,
				tags: ["spectrum", "unbox", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.7071,
						},
					],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: true,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 12,
					detuneCents: -16,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.3536,
						},
						{ type: "high-pass", cutoffHz: 500, linearGain: 1 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.3536,
						},
						{ type: "high-pass", cutoffHz: 500, linearGain: 1 },
					],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 1.5,
					bitcrusherQuantization: 57,
					panDelay: 10,
					chorus: 57,
					echoSustain: 100,
					echoDelayBeats: 1.333,
					reverb: 87,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					spectrum: [
						100, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 57, 0, 0, 57, 0, 43, 0, 43, 0, 0, 29, 0,
						29, 0, 14, 14, 14, 0, 43,
					],
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "rise -2" }],
				},
			},
			{
				name: "Distant",
				midiProgram: 103,
				tags: ["spectrum", "unbox", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.7071,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 1 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 0.7071,
						},
					],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 24,
					detuneCents: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.3536,
						},
						{ type: "high-pass", cutoffHz: 500, linearGain: 1 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.3536,
						},
						{ type: "high-pass", cutoffHz: 500, linearGain: 1 },
					],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 3,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 29,
					echoSustain: 71,
					echoDelayBeats: 1,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					spectrum: [
						100, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 57, 0, 0, 57, 0, 43, 0, 43, 0, 0, 29, 0,
						29, 0, 14, 14, 14, 0, 43,
					],
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "rise -2" }],
				},
			},
			{
				name: "Dark Atmosphere",
				midiProgram: 103,
				tags: ["fm", "fm4op", "unbox", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"pitch shift",
						"note filter",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 24,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					bitcrusherOctave: 3,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 71,
					echoSustain: 57,
					echoDelayBeats: 1.5,
					reverb: 48,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3←4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteFilterFreq", envelope: "wibble 2", index: 0 }],
				},
			},
			{
				name: "Bright Triangle",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 12,
					detuneCents: 4,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 26,
					vibratoSpeed: 1,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 71,
					echoSustain: 57,
					echoDelayBeats: 2,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 2" },
						{
							target: "operatorAmplitude",
							envelope: "twang 3",
							index: 2,
						},
						{ target: "operatorAmplitude", envelope: "twang 1", index: 1 },
					],
				},
			},
			{
				name: "Whisper",
				generalMidi: false,
				tags: ["spectrum", "unbox", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 594.6,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 594.6,
							linearGain: 1.4142,
						},
					],
					effects: ["chord type", "bitcrusher", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					reverb: 65,
					fadeInSeconds: 0.0938,
					fadeOutTicks: 96,
					spectrum: [
						57, 0, 14, 29, 29, 0, 43, 71, 14, 0, 0, 100, 0, 0, 86, 0, 57, 0, 100, 0, 0,
						100, 0, 0, 29, 0, 14, 14, 0, 29,
					],
					unison: "rising",
					envelopes: [],
				},
			},
			{
				name: "Glowing",
				generalMidi: false,
				tags: ["harmonics", "unbox", "novelty"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 0.125,
						},
						{ type: "peak", cutoffHz: 840.9, linearGain: 1.4142 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 353.55, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 0.125,
						},
						{ type: "peak", cutoffHz: 840.9, linearGain: 1.4142 },
					],
					effects: ["transition type", "chorus", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					panDelay: 10,
					chorus: 86,
					reverb: 3,
					fadeInSeconds: 0.0938,
					fadeOutTicks: -3,
					harmonics: [
						57, 0, 0, 14, 0, 0, 0, 0, 100, 57, 86, 71, 0, 100, 0, 0, 0, 29, 0, 0, 14, 0,
						0, 14, 29, 0, 86, 0,
					],
					unison: "spinner",
					envelopes: [],
				},
			},
		]),
	},
	{
		name: "UnBox Synth-Pluck",
		presets: toNameMap([
			{
				name: "Bright Pluck",
				generalMidi: false,
				tags: ["spectrum", "unbox", "picked"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["detune", "note filter", "bitcrusher", "chorus", "echo"],
					detuneCents: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 0,
					panDelay: 10,
					chorus: 14,
					echoSustain: 71,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					spectrum: [
						100, 0, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0, 0, 0,
					],
					unison: "none",
					envelopes: [{ target: "noteVolume", envelope: "twang 1" }],
				},
			},
			{
				name: "Trickle Pluck",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "picked", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 500,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 4 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 500,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 1681.79, linearGain: 4 },
					],
					effects: [
						"chord type",
						"detune",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 11.3137 }],
					distortion: 0,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 43,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←(3 4)",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang -1" },
						{
							target: "noteVolume",
							envelope: "twang -1",
						},
					],
				},
			},
			{
				name: "Hard Pluck",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "picked"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"pitch shift",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 24,
					bitcrusherOctave: 3,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 71,
					echoSustain: 57,
					echoDelayBeats: 1.5,
					reverb: 48,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3←4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~2×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "twang -1", index: 1 },
						{
							target: "operatorAmplitude",
							envelope: "twang 1",
							index: 0,
						},
					],
				},
			},
			{
				name: "Whimsical Pluck",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "echo"],
					transition: "interrupt",
					clicklessTransition: false,
					panDelay: 10,
					echoSustain: 57,
					echoDelayBeats: 0.333,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 100, 100, 100, 71, 0, 57, 100, 57, 0, 29, 0, 29, 0, 43, 43, 43, 0, 0,
						0, 0, 43, 43, 43, 29, 14, 0, 0,
					],
					unison: "fluctuate",
					stringSustain: 21,
					envelopes: [],
				},
			},
			{
				name: "Triangle Pluck",
				generalMidi: false,
				tags: ["chip", "chipwave", "unbox", "novelty"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 8 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.0884 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 8 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.0884 },
					],
					effects: ["transition type", "echo"],
					transition: "interrupt",
					clicklessTransition: false,
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					wave: "Sync Buzzer Test",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 64,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Soft Pluck",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "featured", "picked"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 11.3137 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 11.3137 }],
					effects: [
						"transition type",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 3,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 16,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1→2→3→4",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "2×", amplitude: 10, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 13, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 10, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteVolume", envelope: "twang -1" },
						{
							target: "operatorAmplitude",
							envelope: "flare 1",
							index: 0,
						},
					],
				},
			},
			{
				name: "Muted Pluck",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "picked"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type"],
					transition: "interrupt",
					clicklessTransition: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1 2 3 4",
					feedbackType: "1→2→3→4",
					feedbackAmplitude: 3,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteVolume", envelope: "twang -1" }],
				},
			},
			{
				name: "Shimmer Pluck",
				generalMidi: false,
				tags: ["spectrum", "unbox", "picked"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["bitcrusher", "chorus", "echo"],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 0,
					panDelay: 0,
					chorus: 14,
					echoSustain: 71,
					echoDelayBeats: 1.75,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					spectrum: [
						100, 0, 0, 0, 57, 0, 0, 100, 0, 0, 0, 86, 0, 0, 100, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0, 0, 29,
					],
					unison: "dirty",
					envelopes: [
						{
							target: "noteVolume",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "EEP",
				generalMidi: false,
				tags: ["chip", "chipwave", "unbox", "novelty"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 0.5,
						},
					],
					effects: [
						"transition type",
						"note filter",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 840.9,
							linearGain: 1,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 840.9,
							linearGain: 1,
						},
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					bitcrusherOctave: 6,
					bitcrusherQuantization: 71,
					panDelay: 10,
					chorus: 29,
					echoSustain: 57,
					echoDelayBeats: 1.5,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "C64 TriPulse",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 64,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang -1" }],
				},
			},
			{
				name: "Soft Triangle Pluck",
				generalMidi: false,
				tags: ["chip", "chipwave", "unbox", "picked"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "detune", "note filter", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: -4,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 }],
					panDelay: 10,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "C64 TriPulse",
					unison: "dirty",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 64,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang -1" }],
				},
			},
			{
				name: "Slap Pluck 1",
				generalMidi: false,
				tags: ["chip", "chipwave", "unbox", "picked"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "detune", "note filter", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					detuneCents: -4,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 }],
					panDelay: 10,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "C64 PulseSaw",
					unison: "dirty",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 64,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang -1" }],
				},
			},
			{
				name: "Slap Pluck 2",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "low-pass", cutoffHz: 840.9, linearGain: 2 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 840.9, linearGain: 2 }],
					effects: ["chord type", "bitcrusher", "echo"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					echoSustain: 43,
					echoDelayBeats: 1.167,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					harmonics: [
						71, 71, 71, 86, 100, 71, 71, 57, 71, 57, 57, 43, 57, 57, 57, 57, 57, 71, 71,
						71, 57, 57, 71, 57, 71, 57, 71, 71,
					],
					unison: "shimmer",
					stringSustain: 7,
					envelopes: [],
				},
			},
			{
				name: "String Pluck",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 105.11, linearGain: 0.0884 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 105.11, linearGain: 0.0884 },
					],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"vibrato",
						"note filter",
						"bitcrusher",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 8,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 }],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 57,
					panDelay: 10,
					echoSustain: 43,
					echoDelayBeats: 0.5,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						14, 71, 71, 86, 0, 100, 71, 0, 0, 71, 43, 0, 43, 0, 100, 100, 71, 0, 86, 86,
						100, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "dirty",
					stringSustain: 71,
					envelopes: [],
				},
			},
			{
				name: "Warbled Pluck",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "novelty"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 105.11, linearGain: 0.0884 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 105.11, linearGain: 0.0884 },
					],
					effects: [
						"transition type",
						"chord type",
						"vibrato",
						"note filter",
						"bitcrusher",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 }],
					bitcrusherOctave: 2.5,
					bitcrusherQuantization: 57,
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 0.5,
					reverb: 3,
					fadeInSeconds: 0.1575,
					fadeOutTicks: -1,
					harmonics: [
						14, 71, 71, 86, 0, 100, 71, 0, 0, 71, 43, 0, 43, 0, 100, 100, 71, 0, 86, 86,
						100, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "dirty",
					stringSustain: 71,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "wibble-1" }],
				},
			},
			{
				name: "Watch Pluck",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "low-pass", cutoffHz: 2500, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 6,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["distortion", "chorus", "echo"],
					distortion: 86,
					aliases: false,
					panDelay: 10,
					chorus: 57,
					echoSustain: 100,
					echoDelayBeats: 1.25,
					fadeInSeconds: 0.0575,
					fadeOutTicks: -1,
					harmonics: [
						0, 100, 29, 71, 0, 0, 0, 71, 86, 0, 0, 57, 86, 0, 0, 14, 0, 29, 29, 0, 0, 0,
						0, 86, 0, 0, 0, 0,
					],
					unison: "warbled",
					stringSustain: 36,
					envelopes: [],
				},
			},
			{
				name: "Squeak Pluck",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "peak", cutoffHz: 420.45, linearGain: 0.3536 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "peak", cutoffHz: 420.45, linearGain: 0.3536 }],
					eqSubFilters1: [],
					effects: ["transition type", "note filter", "distortion"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 0.0884,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 4000,
							linearGain: 0.0884,
						},
					],
					distortion: 43,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -1,
					harmonics: [
						86, 0, 57, 0, 0, 0, 71, 0, 0, 0, 0, 0, 29, 0, 0, 14, 0, 0, 0, 0, 0, 0, 100,
						0, 0, 0, 0, 0,
					],
					unison: "bass",
					stringSustain: 7,
					envelopes: [],
				},
			},
		]),
	},
	{
		name: "UnBox Distortion",
		presets: toNameMap([
			{
				name: "Signal Interference",
				generalMidi: false,
				tags: ["spectrum", "unbox", "distortion"],
				settings: {
					type: "spectrum",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"pitch shift",
						"distortion",
						"bitcrusher",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 0,
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					reverb: 81,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					spectrum: [
						0, 0, 0, 0, 0, 0, 0, 100, 71, 71, 71, 71, 71, 71, 100, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Broken Tones",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "distortion"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 7,
					pitchShiftSemitones: 24,
					detuneCents: -200,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 26,
					vibratoSpeed: 1,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 4000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 8 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 2 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 4000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 5656.85, linearGain: 8 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 74.33, linearGain: 2 },
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 8000, linearGain: 11.3137 }],
					distortion: 86,
					aliases: false,
					bitcrusherOctave: 1.5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 0.667,
					reverb: 58,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					algorithm: "1←(2 3←4)",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 2,
					operators: [
						{ frequency: "~1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 2" },
						{
							target: "operatorAmplitude",
							envelope: "twang 3",
							index: 2,
						},
						{ target: "operatorAmplitude", envelope: "twang 1", index: 1 },
					],
				},
			},
			{
				name: "Resonant",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "distortion"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					effects: [
						"transition type",
						"chord type",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: 0,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 26,
					vibratoSpeed: 1,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 2.5,
					bitcrusherQuantization: 57,
					panDelay: 10,
					chorus: 29,
					echoSustain: 71,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 2" },
						{
							target: "operatorAmplitude",
							envelope: "twang 3",
							index: 2,
						},
						{ target: "operatorAmplitude", envelope: "twang 1", index: 1 },
					],
				},
			},
			{
				name: "Corrupted Pulse",
				generalMidi: false,
				tags: ["pwm", "unbox", "distortion", "retro"],
				settings: {
					type: "PWM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "detune", "vibrato", "bitcrusher", "echo"],
					transition: "interrupt",
					clicklessTransition: false,
					detuneCents: 0,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 24,
					vibratoSpeed: 10,
					vibratoType: 0,
					bitcrusherOctave: 3,
					bitcrusherQuantization: 43,
					panDelay: 10,
					echoSustain: 57,
					echoDelayBeats: 1.5,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 12,
					decimalOffset: 0,
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Distorted Pulse",
				generalMidi: false,
				tags: ["pwm", "unbox", "distortion", "retro"],
				settings: {
					type: "PWM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "chord type", "detune", "bitcrusher"],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: 0,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					pulseWidth: 25,
					decimalOffset: 0,
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Fuzzy Distortion",
				generalMidi: false,
				tags: ["fm", "fm6op", "unbox", "distortion"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "high-pass", cutoffHz: 148.65, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 148.65, linearGain: 1 }],
					effects: ["transition type", "note filter", "distortion", "chorus"],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					distortion: 100,
					aliases: false,
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1↔4 2↔5 3↔6",
					feedbackAmplitude: 11,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Soft Distortion",
				generalMidi: false,
				tags: ["fm", "fm6op", "unbox", "featured", "distortion"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "high-pass", cutoffHz: 148.65, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 148.65, linearGain: 1 }],
					effects: ["transition type", "echo", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					panDelay: 10,
					echoSustain: 57,
					echoDelayBeats: 2,
					reverb: 19,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3 2←(4 5)←6",
					feedbackType: "Custom",
					feedbackAmplitude: 6,
					customFeedback: { mods: [[1], [4], [], [], [], []] },
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 1, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Rusted Pulse",
				generalMidi: false,
				tags: ["fm", "fm6op", "unbox", "distortion"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "high-pass", cutoffHz: 148.65, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 148.65, linearGain: 1 }],
					effects: ["transition type", "note filter", "distortion", "chorus"],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					distortion: 100,
					aliases: false,
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1↔4 2↔5 3↔6",
					feedbackAmplitude: 11,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Distorted Pad",
				generalMidi: false,
				tags: ["pwm", "unbox", "distortion", "pad"],
				settings: {
					type: "PWM",
					eqFilter: [{ type: "low-pass", cutoffHz: 2500, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 6,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["note filter", "bitcrusher", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 707.11, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 707.11, linearGain: 1 }],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					reverb: 61,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					pulseWidth: 96,
					decimalOffset: 0,
					unison: "dirty",
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "swell 3" },
						{
							target: "pulseWidth",
							envelope: "rise 3",
						},
					],
				},
			},
		]),
	},
	{
		name: "UnBox Guitar",
		presets: toNameMap([
			{
				name: "Electric Guitar",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "distortion", "guitar"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 11.3137 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 11.3137 }],
					effects: [
						"transition type",
						"pitch shift",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 36,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 14,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "2×", amplitude: 10, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 13, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 10, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteFilterFreq", envelope: "wibble 2", index: 0 }],
				},
			},
			{
				name: "Resonant Guitar",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "featured", "distortion", "guitar"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 11.3137 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2828.43, linearGain: 11.3137 }],
					effects: [
						"transition type",
						"pitch shift",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 36,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 3,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 29,
					echoSustain: 43,
					echoDelayBeats: 1,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1→2→3→4",
					feedbackAmplitude: 11,
					operators: [
						{ frequency: "2×", amplitude: 10, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 13, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 10, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteFilterFreq", envelope: "wibble 2", index: 0 }],
				},
			},
			{
				name: "Distorted Guitar",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "distortion", "guitar"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "peak", cutoffHz: 353.55, linearGain: 11.3137 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "peak", cutoffHz: 353.55, linearGain: 11.3137 }],
					effects: [
						"transition type",
						"pitch shift",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 12,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 100,
					panDelay: 10,
					echoSustain: 29,
					echoDelayBeats: 2,
					reverb: 55,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 100, 0, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0,
					],
					unison: "dirty",
					stringSustain: 71,
					envelopes: [{ target: "noteFilterFreq", envelope: "wibble 2", index: 0 }],
				},
			},
			{
				name: "Guitar Thin",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "distortion", "guitar"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 11.3137 },
					],
					effects: ["transition type", "note filter", "distortion"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					distortion: 71,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 100, 57, 29, 57, 71, 100, 100, 71, 57, 43, 29, 29, 29, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "fifth",
					stringSustain: 71,
					envelopes: [{ target: "noteFilterFreq", envelope: "wibble 2", index: 1 }],
				},
			},
			{
				name: "Guitar Mid",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "distortion", "guitar"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 1 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 4000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 4 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 1 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 4000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 4 },
					],
					effects: ["transition type", "note filter", "distortion", "echo"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					distortion: 71,
					aliases: false,
					panDelay: 10,
					echoSustain: 43,
					echoDelayBeats: 0.25,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						86, 100, 100, 71, 29, 100, 100, 71, 100, 100, 100, 100, 14, 14, 0, 0, 0, 0,
						0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "fifth",
					stringSustain: 71,
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 12,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},
			{
				name: "Guitar High",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "distortion", "guitar"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 1 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 4000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 4 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 1 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 4000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 4 },
					],
					effects: ["transition type", "note filter", "distortion", "chorus", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					distortion: 100,
					aliases: false,
					panDelay: 10,
					chorus: 43,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 100, 100, 100, 100, 100, 100, 86, 86, 71, 71, 57, 100, 100, 0, 0, 0, 0,
						0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "fifth",
					stringSustain: 71,
					envelopes: [{ target: "noteFilterFreq", envelope: "wibble 2", index: 1 }],
				},
			},
			{
				name: "Guitar Ring* Body",
				generalMidi: false,
				tags: ["chip", "chipwave", "unbox", "distortion", "guitar"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 11.3137 },
					],
					eqSubFilters1: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 1 },
						{ type: "peak", cutoffHz: 420.45, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 4000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 4 },
					],
					effects: [
						"transition type",
						"pitch shift",
						"note filter",
						"bitcrusher",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "triangle",
					unison: "none",
					isUsingAdvancedLoopControls: true,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 1,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{ target: "noteFilterFreq", envelope: "wibble 2", index: 0 },
						{
							target: "noteFilterAllFreqs",
							envelope: "note size",
						},
					],
				},
			},
			{
				name: "Guitar Alt",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "distortion", "guitar"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{ type: "peak", cutoffHz: 1000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 5.6569 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.7071 },
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 1 },
						{ type: "peak", cutoffHz: 1000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 5.6569 },
					],
					effects: [
						"chord type",
						"pitch shift",
						"note filter",
						"distortion",
						"chorus",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 2378.41,
							linearGain: 0.7071,
						},
					],
					distortion: 100,
					aliases: false,
					panDelay: 10,
					chorus: 43,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					harmonics: [
						86, 100, 100, 86, 86, 86, 57, 43, 43, 29, 29, 14, 14, 14, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "fifth",
					stringSustain: 71,
					envelopes: [],
				},
			},
			{
				name: "Guitar Body Alt",
				generalMidi: false,
				tags: ["chip", "chipwave", "unbox", "distortion", "guitar"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 0.7071 },
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 2 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.125 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 840.9, linearGain: 11.3137 },
					],
					effects: ["transition type", "pitch shift", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 0,
					panDelay: 10,
					reverb: 39,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Guitar Fuzz",
				generalMidi: false,
				tags: ["fm", "fm6op", "unbox", "distortion", "guitar"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 8 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 2378.41, linearGain: 4 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 8 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 2378.41, linearGain: 4 },
					],
					effects: ["bitcrusher", "chorus"],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 43,
					fadeInSeconds: 0.0413,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4←5←6)",
					feedbackType: "1→2",
					feedbackAmplitude: 10,
					operators: [
						{ frequency: "~1×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 2, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 7, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "11×", amplitude: 4, waveform: "trapezoid", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "rise 1", index: 1 },
						{
							target: "operatorAmplitude",
							envelope: "twang 1",
							index: 5,
						},
						{ target: "feedbackAmplitude", envelope: "rise 2" },
					],
				},
			},
			{
				name: "Guitar High Alt",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "distortion", "guitar"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: [
						"transition type",
						"pitch shift",
						"note filter",
						"distortion",
						"bitcrusher",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "peak", cutoffHz: 353.55, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "peak", cutoffHz: 353.55, linearGain: 11.3137 }],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 100,
					panDelay: 10,
					echoSustain: 29,
					echoDelayBeats: 2,
					reverb: 48,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					harmonics: [
						100, 100, 0, 100, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0,
					],
					unison: "none",
					stringSustain: 71,
					envelopes: [],
				},
			},
			{
				name: "Guitar Lead",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "distortion", "guitar"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 11.3137 },
						{ type: "high-pass", cutoffHz: 594.6, linearGain: 2 },
					],
					effects: ["vibrato", "note filter", "distortion", "chorus", "echo", "reverb"],
					vibrato: "custom",
					vibratoDepth: 0.12,
					vibratoDelay: 0,
					vibratoSpeed: 2,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 4 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.1768 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 4 },
						{ type: "peak", cutoffHz: 707.11, linearGain: 2.8284 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 4756.83, linearGain: 0.1768 },
					],
					distortion: 100,
					aliases: false,
					panDelay: 10,
					chorus: 57,
					echoSustain: 71,
					echoDelayBeats: 1,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					harmonics: [
						100, 100, 86, 71, 71, 71, 86, 86, 71, 57, 57, 57, 57, 57, 43, 43, 29, 29,
						29, 14, 14, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "fifth",
					stringSustain: 71,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 3" }],
				},
			},
			{
				name: "Guitar Lead Body",
				generalMidi: false,
				tags: ["chip", "chipwave", "unbox", "distortion", "guitar"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 2.8284 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 2.8284 }],
					effects: ["transition type", "bitcrusher", "echo"],
					transition: "interrupt",
					clicklessTransition: false,
					bitcrusherOctave: 6,
					bitcrusherQuantization: 100,
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "square",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteVolume", envelope: "twang -1" }],
				},
			},
			{
				name: "Guitar X",
				generalMidi: false,
				tags: ["supersaw", "unbox", "distortion", "guitar"],
				settings: {
					type: "supersaw",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 2378.41, linearGain: 11.3137 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 2.8284 },
						{
							type: "high-pass",
							cutoffHz: 210.22,
							linearGain: 2,
						},
						{ type: "peak", cutoffHz: 2378.41, linearGain: 11.3137 },
					],
					effects: ["transition type", "note filter"],
					transition: "slide",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.5 }],
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					pulseWidth: 45,
					decimalOffset: 0,
					dynamism: 100,
					spread: 25,
					shape: 0,
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "flare 3" },
						{
							target: "pulseWidth",
							envelope: "rise 1",
						},
					],
				},
			},
		]),
	},
	{
		name: "UnBox Picked String",
		presets: toNameMap([
			// Picked String instruments.
			{
				name: "Mandolin Body",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["chord type", "distortion", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					distortion: 14,
					aliases: false,
					panDelay: 10,
					reverb: 32,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						100, 100, 86, 71, 71, 71, 86, 86, 71, 57, 43, 43, 43, 57, 57, 57, 57, 57,
						43, 43, 43, 43, 43, 43, 43, 43, 43, 43,
					],
					unison: "none",
					stringSustain: 71,
					envelopes: [],
				},
			},
			{
				name: "Mandolin Strum",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "distortion", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: true,
					noteSimpleCut: 7,
					noteSimplePeak: 1,
					noteFilter: [],
					distortion: 29,
					aliases: false,
					panDelay: 10,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						86, 100, 100, 100, 86, 57, 86, 100, 100, 100, 71, 57, 43, 71, 86, 71, 57,
						57, 71, 71, 71, 71, 57, 57, 57, 57, 57, 43,
					],
					unison: "dirty",
					stringSustain: 71,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 2" }],
				},
			},
			{
				name: "Mandolin Pluck",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "distortion", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 }],
					distortion: 29,
					aliases: false,
					panDelay: 10,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					harmonics: [
						86, 100, 100, 100, 86, 57, 86, 100, 100, 100, 71, 57, 43, 71, 86, 71, 57,
						57, 71, 71, 71, 71, 57, 57, 57, 57, 57, 43,
					],
					unison: "dirty",
					stringSustain: 71,
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 2" },
						{
							target: "stringSustain",
							envelope: "water-y flutter",
						},
					],
				},
			},
			{
				name: "Banjo Body",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "picked"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: true,
					noteSimpleCut: 6,
					noteSimplePeak: 1,
					noteFilter: [],
					panDelay: 10,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1←(2 3←4)",
					feedbackType: "2⟲",
					feedbackAmplitude: 5,
					operators: [
						{ frequency: "4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "11×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 2" },
						{
							target: "operatorAmplitude",
							envelope: "twang 3",
							index: 2,
						},
					],
				},
			},
			{
				name: "Banjo Pluck",
				generalMidi: false,
				tags: ["harmonics", "unbox", "picked"],
				settings: {
					type: "harmonics",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 176.78, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 1.4142,
						},
					],
					effects: ["chord type", "detune", "note filter", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: 0,
					noteFilterType: true,
					noteSimpleCut: 9,
					noteSimplePeak: 0,
					noteFilter: [],
					panDelay: 10,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						86, 100, 100, 100, 86, 57, 86, 100, 100, 100, 71, 86, 86, 86, 86, 71, 57,
						57, 71, 71, 71, 71, 71, 71, 57, 57, 57, 86,
					],
					unison: "dirty",
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "flare -1" },
						{
							target: "noteFilterFreq",
							envelope: "twang 2",
							index: 0,
						},
						{ target: "detune", envelope: "note size" },
					],
				},
			},
			{
				name: "Resonator Body",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 2 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 1.4142,
						},
					],
					effects: ["transition type", "chord type", "detune", "note filter", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: 0,
					noteFilterType: true,
					noteSimpleCut: 9,
					noteSimplePeak: 1,
					noteFilter: [{ type: "low-pass", cutoffHz: 9656.85, linearGain: 0.5 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 9656.85, linearGain: 0.5 }],
					panDelay: 10,
					reverb: 39,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						86, 100, 100, 100, 86, 57, 86, 100, 100, 100, 71, 57, 43, 71, 86, 71, 57,
						57, 71, 71, 71, 71, 57, 43, 43, 43, 57, 57,
					],
					unison: "dirty",
					stringSustain: 100,
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 2" },
						{
							target: "noteFilterFreq",
							envelope: "twang 3",
							index: 0,
						},
					],
				},
			},
			{
				name: "Resonator Pluck",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 1.4142,
						},
					],
					effects: ["chord type", "detune", "note filter", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: 0,
					noteFilterType: true,
					noteSimpleCut: 9,
					noteSimplePeak: 0,
					noteFilter: [],
					panDelay: 10,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						86, 100, 100, 100, 86, 57, 86, 100, 100, 100, 71, 57, 43, 71, 86, 71, 57,
						57, 71, 71, 71, 71, 71, 71, 57, 57, 57, 86,
					],
					unison: "octave",
					stringSustain: 100,
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "flare -1" },
						{
							target: "noteFilterFreq",
							envelope: "twang 2",
							index: 0,
						},
					],
				},
			},
			{
				name: "Resonator Low Body",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 1.4142 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 125, linearGain: 1.4142 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 1.4142,
						},
					],
					effects: ["transition type", "chord type", "detune", "note filter", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: 0,
					noteFilterType: true,
					noteSimpleCut: 9,
					noteSimplePeak: 1,
					noteFilter: [],
					panDelay: 10,
					reverb: 39,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						86, 100, 100, 100, 86, 57, 86, 100, 100, 100, 71, 57, 43, 71, 86, 71, 57,
						57, 71, 71, 71, 71, 57, 43, 43, 29, 29, 43,
					],
					unison: "dirty",
					stringSustain: 100,
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 2" },
						{
							target: "noteFilterFreq",
							envelope: "twang 3",
							index: 0,
						},
					],
				},
			},
			{
				name: "Resonator Low Pluck",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 105.11, linearGain: 0.7071 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 1.4142,
						},
					],
					effects: ["chord type", "detune", "note filter", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: 0,
					noteFilterType: true,
					noteSimpleCut: 9,
					noteSimplePeak: 0,
					noteFilter: [],
					panDelay: 10,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						86, 100, 100, 100, 86, 57, 86, 100, 100, 100, 71, 57, 43, 71, 86, 71, 57,
						57, 71, 71, 71, 71, 71, 57, 57, 43, 43, 29,
					],
					unison: "octave",
					stringSustain: 100,
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "flare -1" },
						{
							target: "noteFilterFreq",
							envelope: "twang 2",
							index: 0,
						},
					],
				},
			},
		]),
	},
	{
		name: "UnBox Bellows",
		presets: toNameMap([
			{
				name: "Dirty Organ 1",
				generalMidi: false,
				tags: ["harmonics", "unbox", "bellows"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 }],
					effects: ["transition type", "vibrato", "chorus", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.04,
					vibratoDelay: 0,
					vibratoSpeed: 1,
					vibratoType: 0,
					panDelay: 0,
					chorus: 29,
					reverb: 29,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 48,
					harmonics: [
						100, 100, 86, 100, 0, 71, 0, 86, 29, 14, 29, 57, 29, 14, 29, 86, 29, 43, 14,
						43, 14, 43, 29, 57, 29, 14, 14, 14,
					],
					unison: "dirty",
					envelopes: [],
				},
			},
			{
				name: "Dirty Organ 2",
				generalMidi: false,
				tags: ["harmonics", "unbox", "bellows"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 }],
					effects: ["transition type", "vibrato", "chorus", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.04,
					vibratoDelay: 0,
					vibratoSpeed: 1,
					vibratoType: 0,
					panDelay: 0,
					chorus: 29,
					reverb: 29,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 48,
					harmonics: [
						71, 86, 57, 86, 0, 71, 0, 86, 29, 14, 29, 57, 29, 14, 29, 86, 29, 43, 14,
						43, 14, 43, 29, 57, 29, 14, 14, 14,
					],
					unison: "dirty",
					envelopes: [],
				},
			},
			{
				name: "Clean Organ",
				generalMidi: false,
				tags: ["harmonics", "unbox", "bellows"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 }],
					effects: ["transition type", "vibrato", "chorus", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.04,
					vibratoDelay: 0,
					vibratoSpeed: 1,
					vibratoType: 0,
					panDelay: 0,
					chorus: 29,
					reverb: 29,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 48,
					harmonics: [
						100, 86, 43, 100, 0, 43, 0, 86, 0, 0, 0, 43, 0, 0, 0, 86, 0, 0, 0, 0, 0, 0,
						0, 29, 0, 0, 0, 0,
					],
					unison: "dirty",
					envelopes: [],
				},
			},
			{
				name: "Organ Pedal",
				generalMidi: false,
				tags: ["harmonics", "unbox", "bellows"],
				settings: {
					type: "harmonics",
					eqFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 }],
					effects: ["transition type", "vibrato"],
					transition: "interrupt",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.04,
					vibratoDelay: 0,
					vibratoSpeed: 1,
					vibratoType: 0,
					panDelay: 0,
					fadeInSeconds: 0.0125,
					fadeOutTicks: 48,
					harmonics: [
						100, 57, 29, 43, 0, 29, 0, 43, 0, 0, 0, 14, 0, 0, 0, 43, 0, 0, 0, 0, 0, 0,
						0, 14, 0, 0, 0, 0,
					],
					unison: "dirty",
					envelopes: [],
				},
			},
		]),
	},
	{
		name: "UnBox Idiophone",
		presets: toNameMap([
			{
				name: "Soft Chime",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "idiophone"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					effects: [
						"transition type",
						"chord type",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: 0,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 26,
					vibratoSpeed: 1,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 43,
					panDelay: 10,
					chorus: 29,
					echoSustain: 71,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 2" },
						{
							target: "operatorAmplitude",
							envelope: "twang 3",
							index: 2,
						},
						{ target: "operatorAmplitude", envelope: "twang 1", index: 1 },
					],
				},
			},
			{
				name: "Warm Chime",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "idiophone"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 1414.21,
							linearGain: 1.4142,
						},
					],
					effects: ["note filter", "echo", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.5 }],
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 2,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						100, 0, 0, 100, 0, 0, 0, 0, 29, 0, 14, 0, 43, 0, 71, 0, 0, 86, 57, 0, 0,
						100, 0, 43, 0, 71, 71, 43,
					],
					unison: "octave",
					stringSustain: 71,
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Overdrive Chime",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "idiophone", "distortion"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 24,
					detuneCents: 4,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 26,
					vibratoSpeed: 1,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 4,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 71,
					echoSustain: 57,
					echoDelayBeats: 2,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 8, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 2" },
						{
							target: "operatorAmplitude",
							envelope: "twang 3",
							index: 2,
						},
						{ target: "operatorAmplitude", envelope: "decay 3", index: 1 },
					],
				},
			},
			{
				name: "Distorted Chime",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "idiophone", "distortion"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					effects: [
						"transition type",
						"chord type",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: 0,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 26,
					vibratoSpeed: 1,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 3.5,
					bitcrusherQuantization: 57,
					panDelay: 10,
					chorus: 29,
					echoSustain: 71,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 2" },
						{
							target: "operatorAmplitude",
							envelope: "twang 3",
							index: 2,
						},
						{ target: "operatorAmplitude", envelope: "twang 1", index: 1 },
					],
				},
			},
			{
				name: "Dark Chime",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "idiophone"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					effects: [
						"transition type",
						"chord type",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: 0,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 26,
					vibratoSpeed: 1,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					distortion: 86,
					aliases: false,
					bitcrusherOctave: 2.5,
					bitcrusherQuantization: 57,
					panDelay: 10,
					chorus: 29,
					echoSustain: 71,
					echoDelayBeats: 1,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 2" },
						{
							target: "operatorAmplitude",
							envelope: "twang 3",
							index: 2,
						},
						{ target: "operatorAmplitude", envelope: "twang 1", index: 1 },
					],
				},
			},
			{
				name: "Euphonic Array",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "idiophone"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 6727.17, linearGain: 0.7071 }],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
					],
					transition: "normal",
					clicklessTransition: false,
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 24,
					detuneCents: 0,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 26,
					vibratoSpeed: 1,
					vibratoType: 0,
					noteFilterType: true,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					distortion: 14,
					aliases: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					chorus: 29,
					echoSustain: 14,
					echoDelayBeats: 2,
					fadeInSeconds: 0.1575,
					fadeOutTicks: 48,
					algorithm: "(1 2)←(3 4)",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "~1×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 2" },
						{
							target: "operatorAmplitude",
							envelope: "twang 3",
							index: 2,
						},
						{ target: "operatorAmplitude", envelope: "twang 1", index: 1 },
					],
				},
			},
			{
				name: "Glass Armonica",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "idiophone"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["chord type", "note filter", "reverb"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: true,
					noteSimpleCut: 8,
					noteSimplePeak: 2,
					noteFilter: [{ type: "low-pass", cutoffHz: 4787.19, linearGain: 1 }],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4787.19, linearGain: 1 }],
					panDelay: 10,
					reverb: 100,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1 2 3 4",
					feedbackType: "1→2→3→4",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "16×", amplitude: 5, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteVolume", envelope: "flare 3" },
						{
							target: "noteVolume",
							envelope: "punch",
						},
					],
				},
			},
			{
				name: "Struck Music Box",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "idiophone"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "echo", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 0.5,
					reverb: 68,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					harmonics: [
						100, 0, 0, 57, 0, 0, 100, 0, 0, 0, 0, 0, 86, 0, 0, 86, 0, 0, 0, 0, 0, 0, 0,
						29, 0, 0, 0, 0,
					],
					unison: "none",
					stringSustain: 71,
					envelopes: [],
				},
			},
			{
				name: "Jawharp",
				generalMidi: false,
				tags: ["chip", "chipwave", "unbox", "idiophone"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 1 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 1 }],
					effects: ["transition type", "pitch shift", "note filter", "chorus", "echo"],
					transition: "normal",
					clicklessTransition: false,
					pitchShiftSemitones: 36,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 1681.79, linearGain: 8 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 8 },
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 1681.79, linearGain: 8 },
						{ type: "peak", cutoffHz: 88.39, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 353.55, linearGain: 11.3137 },
						{ type: "low-pass", cutoffHz: 8000, linearGain: 1 },
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 8 },
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 4756.83, linearGain: 1.4142 }],
					panDelay: 10,
					chorus: 29,
					echoSustain: 29,
					echoDelayBeats: 0.083,
					fadeInSeconds: 0,
					fadeOutTicks: 96,
					wave: "sawtooth",
					unison: "piano",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 2,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{ target: "noteFilterFreq", envelope: "tremolo6", index: 0 },
						{ target: "pitchShift", envelope: "flare 1" },
						{ target: "pitchShift", envelope: "twang -1" },
						{ target: "pitchShift", envelope: "twang -1" },
						{ target: "pitchShift", envelope: "twang -1" },
						{ target: "pitchShift", envelope: "flare -1" },
						{ target: "noteFilterFreq", envelope: "punch", index: 0 },
					],
				},
			},
			{
				name: "Wooden Tube",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "idiophone"],
				settings: {
					type: "Picked String",
					eqFilter: [{ type: "low-pass", cutoffHz: 2500, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 6,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["vibrato", "note filter", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 9513.66, linearGain: 1 }],
					panDelay: 10,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: 12,
					harmonics: [
						71, 86, 0, 0, 0, 43, 0, 0, 0, 71, 14, 0, 0, 57, 100, 0, 0, 0, 71, 0, 0, 0,
						14, 0, 0, 0, 29, 57,
					],
					unison: "none",
					stringSustain: 0,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "twang 1" }],
				},
			},
		]),
	},
	{
		name: "UnBox Noise",
		presets: toNameMap([
			{
				name: "Metallic Hiss",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "sfx"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["transition type", "bitcrusher", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 43,
					panDelay: 0,
					reverb: 58,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1→2→3→4",
					feedbackAmplitude: 9,
					operators: [
						{ frequency: "20×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 7, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
					],
				},
			},
			{
				name: "Noisy Horn",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "sfx"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.0884 }],
					eqFilterType: true,
					eqSimpleCut: 0,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["transition type", "pitch shift", "detune", "bitcrusher", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 0,
					detuneCents: 0,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 57,
					panDelay: 10,
					reverb: 58,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(2 3 4)",
					feedbackType: "1→2→3→4",
					feedbackAmplitude: 9,
					operators: [
						{ frequency: "20×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 13, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 11, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "operatorAmplitude", envelope: "punch", index: 3 }],
				},
			},
			{
				name: "Distant Hiss",
				generalMidi: false,
				tags: ["spectrum", "unbox", "ambience"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.7071 }],
					eqSubFilters1: [],
					effects: ["chord type", "detune", "note filter", "reverb"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					detuneCents: 132,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 3363.59, linearGain: 1.4142 }],
					panDelay: 10,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					spectrum: [
						43, 43, 29, 29, 0, 14, 43, 43, 57, 0, 14, 57, 57, 71, 71, 0, 57, 86, 71,
						100, 86, 57, 0, 0, 71, 57, 100, 43, 14, 0,
					],
					unison: "none",
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "swell 2" }],
				},
			},
			{
				name: "Full Spectrum Hiss",
				generalMidi: false,
				tags: ["spectrum", "unbox", "ambience"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1.4142 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 1.4142,
						},
					],
					eqSubFilters1: [],
					effects: ["chord type", "pitch shift", "detune", "note filter", "reverb"],
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 24,
					detuneCents: 200,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "high-pass", cutoffHz: 594.6, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "high-pass", cutoffHz: 594.6, linearGain: 0.7071 }],
					panDelay: 10,
					reverb: 52,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					spectrum: [
						100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
						100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100,
					],
					unison: "none",
					envelopes: [],
				},
			},
			{
				name: "Clicky",
				generalMidi: false,
				tags: ["noise", "unbox", "drum"],
				settings: {
					type: "noise",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 11313.71,
							linearGain: 5.6569,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 210.22, linearGain: 0.5 },
						{
							type: "peak",
							cutoffHz: 11313.71,
							linearGain: 5.6569,
						},
					],
					eqSubFilters1: [],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"detune",
						"bitcrusher",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 26,
					detuneCents: 0,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 57,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "1-bit white",
					unison: "none",
					envelopes: [
						{ target: "noteVolume", envelope: "note size" },
						{ target: "pitchShift", envelope: "note size" },
						{ target: "noteVolume", envelope: "twang -1" },
						{ target: "pitchShift", envelope: "twang -1" },
						{ target: "pitchShift", envelope: "decay -1" },
						{ target: "noteVolume", envelope: "blip 3" },
					],
				},
			},
			{
				name: "Crackle",
				generalMidi: false,
				tags: ["noise", "unbox", "ambience"],
				settings: {
					type: "noise",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 1,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1681.79, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 500,
							linearGain: 1,
						},
					],
					eqSubFilters1: [],
					effects: [
						"transition type",
						"pitch shift",
						"detune",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "slide in pattern",
					clicklessTransition: false,
					pitchShiftSemitones: 36,
					detuneCents: 200,
					distortion: 29,
					aliases: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 57,
					panDelay: 10,
					chorus: 29,
					echoSustain: 14,
					echoDelayBeats: 0.25,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					wave: "crackling",
					unison: "none",
					envelopes: [],
				},
			},
		]),
	},
	{
		name: "UnBox Nightmareophone",
		presets: toNameMap([
			{
				name: "Damaged Calliope",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "flute"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 2948.87, linearGain: 2 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 4,
					eqSubFilters1: [],
					effects: ["chorus"],
					panDelay: 10,
					chorus: 86,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←3 2←4",
					feedbackType: "1→3 2→4",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 10, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "pulse width", pulseWidth: 6 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "swell 1", index: 2 },
						{
							target: "operatorAmplitude",
							envelope: "wibble 1",
							index: 3,
						},
					],
				},
			},
			{
				name: "Distorted Growl",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "distortion"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 2948.87, linearGain: 2 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 4,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["bitcrusher", "chorus"],
					bitcrusherOctave: 1,
					bitcrusherQuantization: 71,
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←3 2←4",
					feedbackType: "1→3 2→4",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 10, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "pulse width", pulseWidth: 6 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "operatorAmplitude", envelope: "wibble 1", index: 3 }],
				},
			},
			{
				name: "Dirty Noise",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "distortion"],
				settings: {
					type: "FM",
					eqFilter: [{ type: "low-pass", cutoffHz: 2948.87, linearGain: 2 }],
					eqFilterType: true,
					eqSimpleCut: 7,
					eqSimplePeak: 4,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["bitcrusher", "chorus"],
					bitcrusherOctave: 1,
					bitcrusherQuantization: 71,
					panDelay: 10,
					chorus: 29,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					algorithm: "1←3 2←4",
					feedbackType: "1→3 2→4",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "8×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 10, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "pulse width", pulseWidth: 6 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "operatorAmplitude", envelope: "wibble 1", index: 3 }],
				},
			},
			{
				name: "Shrill Horn",
				generalMidi: false,
				tags: ["fm", "fm6op", "unbox", "bass"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					eqSubFilters1: [],
					effects: ["vibrato", "note filter", "bitcrusher", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1 }],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "8×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 14, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 15, waveform: "ramp", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 3" },
						{
							target: "feedbackAmplitude",
							envelope: "wibble 1",
						},
					],
				},
			},
			{
				name: "Shrill Bass",
				generalMidi: false,
				tags: ["fm", "fm6op", "unbox", "bass"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 0.0884,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 420.45, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 840.9,
							linearGain: 0.0884,
						},
					],
					eqSubFilters1: [],
					effects: ["pitch shift", "vibrato", "note filter", "bitcrusher", "reverb"],
					pitchShiftSemitones: 12,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1 }],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "8×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 14, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 15, waveform: "ramp", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 3" },
						{
							target: "feedbackAmplitude",
							envelope: "wibble 1",
						},
					],
				},
			},
			{
				name: "Shrill Growl",
				generalMidi: false,
				tags: ["fm", "fm6op", "unbox", "bass", "distortion"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					eqFilterType: true,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["vibrato", "note filter", "bitcrusher", "reverb"],
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 1 }],
					bitcrusherOctave: 4,
					bitcrusherQuantization: 71,
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1 2 3 4 5 6",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲ 5⟲ 6⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "8×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 14, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 15, waveform: "ramp", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "twang 3" },
						{
							target: "feedbackAmplitude",
							envelope: "wibble 1",
						},
					],
				},
			},
			{
				name: "Fuzzy Generator",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "distortion"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 8,
						},
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 8,
						},
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2 },
					],
					effects: ["chord type", "note filter", "distortion", "bitcrusher", "echo"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 5.6569 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 5.6569 }],
					distortion: 100,
					aliases: false,
					bitcrusherOctave: 5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 1,
					fadeInSeconds: 0.0575,
					fadeOutTicks: 12,
					algorithm: "(1 2)←3←4",
					feedbackType: "2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.25×", amplitude: 14, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 2, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Distorted Generator",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "distortion"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 8,
						},
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 8,
						},
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2 },
					],
					effects: ["chord type", "note filter", "distortion", "bitcrusher", "echo"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 5.6569 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 5.6569 }],
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 2.5,
					bitcrusherQuantization: 57,
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 1,
					fadeInSeconds: 0.0575,
					fadeOutTicks: 12,
					algorithm: "(1 2)←3←4",
					feedbackType: "2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.25×", amplitude: 14, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 11, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 3, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Dirty Buzz",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "distortion"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 8,
						},
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 11313.71, linearGain: 11.3137 },
						{
							type: "peak",
							cutoffHz: 5656.85,
							linearGain: 8,
						},
						{ type: "peak", cutoffHz: 1414.21, linearGain: 2 },
					],
					effects: ["chord type", "note filter", "distortion", "bitcrusher", "echo"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 5.6569 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 5.6569 }],
					distortion: 71,
					aliases: false,
					bitcrusherOctave: 2.5,
					bitcrusherQuantization: 57,
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 1,
					fadeInSeconds: 0.0575,
					fadeOutTicks: 12,
					algorithm: "(1 2)←3←4",
					feedbackType: "2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.25×", amplitude: 14, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.12×", amplitude: 11, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 3, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 13, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Drill",
				generalMidi: false,
				tags: ["fm", "fm6op", "unbox", "distortion"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.125,
						},
						{ type: "peak", cutoffHz: 11313.71, linearGain: 0.3536 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 2828.43,
							linearGain: 0.125,
						},
						{ type: "peak", cutoffHz: 11313.71, linearGain: 0.3536 },
					],
					effects: ["note filter", "distortion", "echo"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 2,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 0.7071 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 2,
						},
					],
					distortion: 86,
					aliases: false,
					panDelay: 0,
					echoSustain: 43,
					echoDelayBeats: 1.25,
					fadeInSeconds: 0,
					fadeOutTicks: 48,
					algorithm: "1 2←4 3←(5 6)",
					feedbackType: "ALL",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "3.5×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "0.25×", amplitude: 12, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 14, waveform: "pulse width", pulseWidth: 10 },
						{ frequency: "1×", amplitude: 1, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 3, waveform: "triangle", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Electrical",
				generalMidi: false,
				tags: ["fm", "fm6op", "unbox", "distortion", "bass"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 13454.34,
							linearGain: 8,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.0884 },
						{
							type: "peak",
							cutoffHz: 13454.34,
							linearGain: 8,
						},
					],
					effects: ["note filter", "distortion", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.7071 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.25 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 0.7071,
						},
						{ type: "peak", cutoffHz: 353.55, linearGain: 0.7071 },
					],
					distortion: 86,
					aliases: false,
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3 2←4←(5 6)",
					feedbackType: "3→4",
					feedbackAmplitude: 9,
					operators: [
						{ frequency: "~1×", amplitude: 11, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 12, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 3, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "6×", amplitude: 6, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.75×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "operatorAmplitude",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 4,
						},
					],
				},
			},
			{
				name: "Digi Scream",
				generalMidi: false,
				tags: ["fm", "fm6op", "unbox", "distortion"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 4756.83,
							linearGain: 1.4142,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 3363.59, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 4756.83,
							linearGain: 1.4142,
						},
					],
					effects: ["pitch shift", "note filter", "distortion", "reverb"],
					pitchShiftSemitones: 14,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 8 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 0.7071,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 2000, linearGain: 8 },
						{
							type: "high-pass",
							cutoffHz: 297.3,
							linearGain: 0.7071,
						},
					],
					distortion: 86,
					aliases: false,
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←(3 4)←5 2←6",
					feedbackType: "3⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.12×", amplitude: 13, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "17×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{
							frequency: "0.75×",
							amplitude: 0,
							waveform: "pulse width",
							pulseWidth: 5,
						},
						{ frequency: "~2×", amplitude: 7, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "3.5×", amplitude: 10, waveform: "triangle", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
					],
				},
			},
			{
				name: "Alarm Drill",
				generalMidi: false,
				tags: ["fm", "fm6op", "unbox", "sfx"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 1681.79,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 1681.79,
							linearGain: 2.8284,
						},
					],
					eqSubFilters1: [],
					effects: ["transition type", "pitch shift", "bitcrusher", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					pitchShiftSemitones: 2,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 29,
					panDelay: 0,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1→2→3→4→5→6",
					feedbackAmplitude: 11,
					operators: [
						{
							frequency: "3.5×",
							amplitude: 13,
							waveform: "pulse width",
							pulseWidth: 2,
						},
						{ frequency: "15×", amplitude: 4, waveform: "pulse width", pulseWidth: 0 },
						{ frequency: "~2×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 8, waveform: "pulse width", pulseWidth: 10 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 0, waveform: "sawtooth", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
					],
				},
			},
			{
				name: "Run",
				generalMidi: false,
				tags: ["supersaw", "unbox", "novelty"],
				settings: {
					type: "supersaw",
					eqFilter: [{ type: "low-pass", cutoffHz: 2500, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 6,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters1: [],
					effects: ["transition type", "chord type", "note filter", "echo", "reverb"],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: true,
					arpeggioSpeed: 12,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 }],
					panDelay: 10,
					echoSustain: 100,
					echoDelayBeats: 1.167,
					reverb: 3,
					fadeInSeconds: 0.0575,
					fadeOutTicks: 6,
					pulseWidth: 40,
					decimalOffset: 0,
					dynamism: 100,
					spread: 100,
					shape: 0,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "punch" }],
				},
			},
			{
				name: "No Signal",
				generalMidi: false,
				tags: ["fm", "fm6op", "unbox", "sfx", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 0.3536,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 1 },
						{
							type: "peak",
							cutoffHz: 1189.21,
							linearGain: 0.3536,
						},
					],
					effects: ["note filter", "bitcrusher"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 11.3137 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 11.3137 }],
					bitcrusherOctave: 6,
					bitcrusherQuantization: 57,
					panDelay: 0,
					fadeInSeconds: 0.0125,
					fadeOutTicks: -1,
					algorithm: "Custom",
					feedbackType: "ALL",
					feedbackAmplitude: 14,
					customAlgorithm: { mods: [[2, 3, 4], [], [5], [6], [], []], carrierCount: 1 },
					operators: [
						{ frequency: "0.25×", amplitude: 14, waveform: "sine", pulseWidth: 5 },
						{
							frequency: "0.75×",
							amplitude: 5,
							waveform: "pulse width",
							pulseWidth: 6,
						},
						{ frequency: "1×", amplitude: 0, waveform: "pulse width", pulseWidth: 1 },
						{ frequency: "~1×", amplitude: 0, waveform: "pulse width", pulseWidth: 3 },
						{ frequency: "0.75×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 5, waveform: "sawtooth", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
						{
							target: "operatorAmplitude",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 8,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0.5,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
							waveform: 0,
							steps: 2,
						},
						{
							target: "feedbackAmplitude",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "You shouldn't be here",
				generalMidi: false,
				tags: ["fm", "fm6op", "unbox", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [{ type: "low-pass", cutoffHz: 2500, linearGain: 0.5 }],
					eqFilterType: true,
					eqSimpleCut: 6,
					eqSimplePeak: 1,
					envelopeSpeed: 12,
					eqSubFilters1: [],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.3536 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 4000, linearGain: 0.3536 }],
					panDelay: 10,
					reverb: 13,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←4(2←5(3←6",
					feedbackType: "3⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "0.5×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 14, waveform: "triangle", pulseWidth: 5 },
						{
							frequency: "0.75×",
							amplitude: 15,
							waveform: "quasi-sine",
							pulseWidth: 5,
						},
						{ frequency: "1×", amplitude: 7, waveform: "triangle", pulseWidth: 5 },
						{
							frequency: "0.75×",
							amplitude: 1,
							waveform: "pulse width",
							pulseWidth: 5,
						},
						{ frequency: "10×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "wibble",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "operatorAmplitude",
							envelope: "flare",
							inverse: false,
							perEnvelopeSpeed: 2,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 5,
						},
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Spook",
				generalMidi: false,
				tags: ["pwm", "unbox", "distortion"],
				settings: {
					type: "PWM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.125,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 8000, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.125,
						},
					],
					effects: [
						"transition type",
						"vibrato",
						"note filter",
						"distortion",
						"echo",
						"reverb",
					],
					transition: "slide",
					clicklessTransition: false,
					vibrato: "heavy",
					vibratoDepth: 0.45,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 4,
						},
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 0.5 },
						{
							type: "high-pass",
							cutoffHz: 594.6,
							linearGain: 4,
						},
					],
					distortion: 57,
					aliases: false,
					panDelay: 10,
					echoSustain: 57,
					echoDelayBeats: 0.75,
					reverb: 6,
					fadeInSeconds: 0,
					fadeOutTicks: 24,
					pulseWidth: 49,
					decimalOffset: 0,
					unison: "hecking gosh",
					envelopes: [{ target: "pulseWidth", envelope: "swell 1" }],
				},
			},
		]),
	},
	{
		name: "UnBox Misc",
		presets: toNameMap([
			{
				name: "Synth Calliope",
				midiProgram: 76,
				tags: ["spectrum", "unbox", "flute"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "peak", cutoffHz: 250, linearGain: 0.5 },
						{
							type: "low-pass",
							cutoffHz: 8000,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "peak", cutoffHz: 250, linearGain: 0.5 },
						{
							type: "low-pass",
							cutoffHz: 8000,
							linearGain: 0.5,
						},
					],
					effects: [
						"chord type",
						"pitch shift",
						"detune",
						"note filter",
						"distortion",
						"bitcrusher",
						"reverb",
					],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 36,
					detuneCents: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 1 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 0.7071,
						},
					],
					noteSubFilters0: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 1 },
						{
							type: "low-pass",
							cutoffHz: 5656.85,
							linearGain: 0.7071,
						},
					],
					distortion: 0,
					aliases: false,
					bitcrusherOctave: 6,
					bitcrusherQuantization: 0,
					panDelay: 10,
					reverb: 26,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					spectrum: [
						100, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 57, 0, 0, 57, 0, 43, 0, 43, 0, 0, 29, 0,
						29, 0, 14, 14, 14, 0, 0,
					],
					unison: "dirty",
					envelopes: [],
				},
			},
			{
				name: "Synth Flute",
				generalMidi: false,
				tags: ["chip", "chipwave", "unbox", "flute"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "low-pass", cutoffHz: 16000, linearGain: 0.7071 }],
					effects: [
						"transition type",
						"vibrato",
						"distortion",
						"bitcrusher",
						"chorus",
						"reverb",
					],
					transition: "normal",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 4,
					vibratoSpeed: 8,
					vibratoType: 0,
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					chorus: 29,
					reverb: 65,
					fadeInSeconds: 0.1575,
					fadeOutTicks: 6,
					wave: "SID 6581 Triangle",
					unison: "dirty",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 278,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [],
				},
			},
			{
				name: "Crunchy Pluck",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "picked"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 105.11, linearGain: 0.0884 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 105.11, linearGain: 0.0884 },
					],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"vibrato",
						"note filter",
						"bitcrusher",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "simultaneous",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					pitchShiftSemitones: 24,
					vibrato: "none",
					vibratoDepth: 0,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 }],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 57,
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 0.5,
					reverb: 3,
					fadeInSeconds: 0.1575,
					fadeOutTicks: -1,
					harmonics: [
						14, 71, 71, 86, 0, 100, 71, 0, 0, 71, 43, 0, 43, 0, 100, 100, 71, 0, 86, 86,
						100, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "dirty",
					stringSustain: 71,
					envelopes: [],
				},
			},
			{
				name: "Crunchy Scream",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "distortion", "novelty"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 105.11, linearGain: 0.0884 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 420.45,
							linearGain: 0.25,
						},
						{ type: "peak", cutoffHz: 105.11, linearGain: 0.0884 },
					],
					effects: [
						"transition type",
						"chord type",
						"pitch shift",
						"vibrato",
						"note filter",
						"bitcrusher",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					chord: "arpeggio",
					fastTwoNoteArp: false,
					arpeggioSpeed: 1,
					pitchShiftSemitones: 24,
					vibrato: "shaky",
					vibratoDepth: 0.1,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 1,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 2.8284 }],
					bitcrusherOctave: 1.5,
					bitcrusherQuantization: 57,
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 0.5,
					reverb: 32,
					fadeInSeconds: 0.1575,
					fadeOutTicks: -1,
					harmonics: [
						14, 71, 71, 86, 0, 100, 71, 0, 0, 71, 43, 0, 43, 0, 100, 100, 71, 0, 86, 86,
						100, 0, 0, 0, 0, 0, 0, 0,
					],
					unison: "dirty",
					stringSustain: 71,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "wibble-1" }],
				},
			},
			{
				name: "Picked Bass Body",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "picked", "bass"],
				settings: {
					type: "Picked String",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["pitch shift", "distortion"],
					pitchShiftSemitones: 12,
					distortion: 14,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					harmonics: [
						100, 86, 71, 43, 29, 43, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
						0, 0, 0, 0, 0,
					],
					unison: "dirty",
					stringSustain: 79,
					envelopes: [
						{ target: "unison", envelope: "twang -1" },
						{
							target: "noteVolume",
							envelope: "decay 3",
						},
						{ target: "noteVolume", envelope: "twang 3" },
					],
				},
			},
			{
				name: "Picked Bass Pluck",
				generalMidi: false,
				tags: ["pickedstring", "unbox", "picked", "bass"],
				settings: {
					type: "Picked String",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 1,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 0.7071 },
						{
							type: "high-pass",
							cutoffHz: 74.33,
							linearGain: 1,
						},
					],
					eqSubFilters1: [],
					effects: ["pitch shift", "distortion"],
					pitchShiftSemitones: 24,
					distortion: 14,
					aliases: false,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					harmonics: [
						100, 86, 71, 43, 29, 29, 29, 43, 43, 29, 29, 29, 29, 29, 29, 29, 14, 14, 14,
						14, 14, 14, 14, 14, 14, 14, 14, 14,
					],
					unison: "dirty",
					stringSustain: 79,
					envelopes: [
						{ target: "unison", envelope: "twang -1" },
						{
							target: "noteVolume",
							envelope: "decay 3",
						},
						{ target: "noteVolume", envelope: "twang 3" },
					],
				},
			},
		]),
	},
	{
		name: "UnBox Novelty",
		presets: toNameMap([
			// UnBox Noise
			{
				name: "Distant Woosh",
				generalMidi: false,
				tags: ["spectrum", "unbox", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 2 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.1768 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1.4142 },
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 2 },
						{ type: "peak", cutoffHz: 1189.21, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.1768 },
						{ type: "peak", cutoffHz: 500, linearGain: 0.1768 },
					],
					effects: [
						"transition type",
						"pitch shift",
						"detune",
						"vibrato",
						"note filter",
						"distortion",
						"bitcrusher",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					pitchShiftSemitones: 23,
					detuneCents: 196,
					vibrato: "custom",
					vibratoDepth: 0.16,
					vibratoDelay: 36,
					vibratoSpeed: 2,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 4 },
						{ type: "peak", cutoffHz: 500, linearGain: 2 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.25 },
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.0884 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 9513.66, linearGain: 4 },
						{ type: "peak", cutoffHz: 500, linearGain: 2 },
						{ type: "peak", cutoffHz: 2828.43, linearGain: 0.25 },
						{ type: "high-pass", cutoffHz: 148.65, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 1414.21, linearGain: 0.0884 },
					],
					distortion: 43,
					aliases: false,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					chorus: 57,
					echoSustain: 71,
					echoDelayBeats: 1.583,
					reverb: 87,
					fadeInSeconds: 0,
					fadeOutTicks: 6,
					spectrum: [
						0, 0, 0, 29, 43, 57, 57, 43, 57, 29, 29, 29, 43, 29, 57, 29, 57, 29, 29, 0,
						14, 43, 43, 29, 14, 14, 0, 0, 0, 14,
					],
					unison: "none",
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "rise -2" },
						{
							target: "vibratoDepth",
							envelope: "swell -1",
						},
					],
				},
			},

			// UnBox Voiced
			{
				name: "Vowel Ah",
				generalMidi: false,
				tags: ["chip", "chipwave", "unbox", "novelty"],
				settings: {
					type: "chip",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 4 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 1000, linearGain: 4 },
						{
							type: "high-pass",
							cutoffHz: 353.55,
							linearGain: 0.5,
						},
					],
					effects: ["pitch shift", "note filter", "reverb"],
					pitchShiftSemitones: 25,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.25 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 5656.85, linearGain: 0.25 }],
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: 0,
					wave: "YM2149f Soft Buzzer V",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 64,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{ target: "pitchShift", envelope: "flare 2" },
						{
							target: "noteFilterAllFreqs",
							envelope: "punch",
						},
					],
				},
			},
			{
				name: "Vowel Eh",
				generalMidi: false,
				tags: ["chip", "chipwave", "unbox", "novelty"],
				settings: {
					type: "chip",
					eqFilter: [{ type: "peak", cutoffHz: 2000, linearGain: 11.3137 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "peak", cutoffHz: 2000, linearGain: 11.3137 }],
					effects: ["note filter", "reverb"],
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 8000, linearGain: 0.7071 }],
					panDelay: 10,
					reverb: 29,
					fadeInSeconds: 0.0263,
					fadeOutTicks: 6,
					wave: "SID 6581 Tri+pulse",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 338,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [{ target: "noteFilterAllFreqs", envelope: "linear-1" }],
				},
			},
			{
				name: "Vowel Oh",
				generalMidi: false,
				tags: ["chip", "chipwave", "unbox", "novelty", "featured"],
				settings: {
					type: "chip",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 4,
					eqSubFilters0: [],
					effects: ["transition type", "note filter", "distortion", "echo"],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
					],
					noteSubFilters0: [
						{ type: "low-pass", cutoffHz: 6727.17, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 2000, linearGain: 11.3137 },
						{ type: "peak", cutoffHz: 1000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 4000, linearGain: 0.0884 },
					],
					noteSubFilters1: [{ type: "low-pass", cutoffHz: 19027.31, linearGain: 0.7071 }],
					distortion: 43,
					aliases: false,
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 0.5,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					wave: "sawtooth",
					unison: "none",
					isUsingAdvancedLoopControls: false,
					chipWaveLoopStart: 0,
					chipWaveLoopEnd: 32,
					chipWaveLoopMode: 0,
					chipWavePlayBackwards: false,
					chipWaveStartOffset: 0,
					envelopes: [
						{
							target: "noteFilterFreq",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 0,
						},
						{
							target: "noteFilterFreq",
							envelope: "decay",
							inverse: false,
							perEnvelopeSpeed: 4,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 1,
						},
					],
				},
			},

			// UnBox Funny
			{
				name: "🦆",
				generalMidi: false,
				tags: ["fm", "fm6op", "unbox", "novelty", "sfx"],
				settings: {
					type: "FM6op",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 1681.79,
							linearGain: 2.8284,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 9,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 2828.43, linearGain: 4 },
						{
							type: "peak",
							cutoffHz: 1681.79,
							linearGain: 2.8284,
						},
					],
					eqSubFilters1: [],
					effects: ["transition type", "pitch shift", "bitcrusher", "reverb"],
					transition: "slide",
					clicklessTransition: false,
					pitchShiftSemitones: 2,
					bitcrusherOctave: 5.5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					reverb: 3,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←2←3←4←5←6",
					feedbackType: "1→2→3→4→5→6",
					feedbackAmplitude: 11,
					operators: [
						{
							frequency: "3.5×",
							amplitude: 13,
							waveform: "pulse width",
							pulseWidth: 1,
						},
						{ frequency: "15×", amplitude: 4, waveform: "pulse width", pulseWidth: 0 },
						{ frequency: "~2×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~4×", amplitude: 8, waveform: "pulse width", pulseWidth: 6 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "~1×", amplitude: 0, waveform: "sawtooth", pulseWidth: 5 },
					],
					envelopes: [
						{
							target: "pitchShift",
							envelope: "twang",
							inverse: false,
							perEnvelopeSpeed: 32,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "operatorAmplitude",
							envelope: "rise",
							inverse: false,
							perEnvelopeSpeed: 128,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							index: 3,
						},
						{
							target: "feedbackAmplitude",
							envelope: "lfo",
							inverse: false,
							perEnvelopeSpeed: 1,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
							waveform: 0,
							steps: 2,
						},
						{
							target: "noteVolume",
							envelope: "blip",
							inverse: false,
							perEnvelopeSpeed: 6,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
						{
							target: "noteVolume",
							envelope: "swell",
							inverse: false,
							perEnvelopeSpeed: 256,
							perEnvelopeLowerBound: 0,
							perEnvelopeUpperBound: 1,
							discrete: false,
						},
					],
				},
			},
			{
				name: "Aouw Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					eqSubFilters1: [],
					effects: ["detune", "note filter", "bitcrusher", "reverb"],
					detuneCents: 16,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 1000, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 8,
						},
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 1000, linearGain: 5.6569 },
						{
							type: "peak",
							cutoffHz: 2378.41,
							linearGain: 8,
						},
					],
					bitcrusherOctave: 5,
					bitcrusherQuantization: 0,
					panDelay: 10,
					reverb: 0,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 8,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "100×", amplitude: 2, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "operatorAmplitude", envelope: "punch", index: 3 },
						{ target: "feedbackAmplitude", envelope: "decay 2" },
						{ target: "operatorAmplitude", envelope: "twang 3", index: 1 },
						{ target: "noteFilterAllFreqs", envelope: "twang 3" },
					],
				},
			},
			{
				name: "Broken Bass",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					eqSubFilters1: [],
					effects: ["transition type", "detune", "bitcrusher"],
					transition: "normal",
					clicklessTransition: true,
					detuneCents: 0,
					bitcrusherOctave: 4.5,
					bitcrusherQuantization: 29,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 4,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 9, waveform: "sine", pulseWidth: 5 },
						{ frequency: "100×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [{ target: "noteVolume", envelope: "note size" }],
				},
			},
			{
				name: "OWU",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "low-pass", cutoffHz: 4756.83, linearGain: 0.3536 },
						{
							type: "high-pass",
							cutoffHz: 148.65,
							linearGain: 0.5,
						},
					],
					eqSubFilters1: [],
					effects: ["pitch shift", "detune", "note filter", "bitcrusher", "reverb"],
					pitchShiftSemitones: 28,
					detuneCents: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [
						{ type: "peak", cutoffHz: 1000, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 8 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1 },
					],
					noteSubFilters0: [
						{ type: "peak", cutoffHz: 1000, linearGain: 5.6569 },
						{ type: "peak", cutoffHz: 2378.41, linearGain: 8 },
						{ type: "peak", cutoffHz: 1681.79, linearGain: 0.0884 },
						{ type: "low-pass", cutoffHz: 4000, linearGain: 1 },
					],
					bitcrusherOctave: 5,
					bitcrusherQuantization: 14,
					panDelay: 10,
					reverb: 23,
					fadeInSeconds: 0,
					fadeOutTicks: -3,
					algorithm: "1←(2 3 4)",
					feedbackType: "1⟲ 2⟲ 3⟲ 4⟲",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 4, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 8, waveform: "sine", pulseWidth: 5 },
						{ frequency: "20×", amplitude: 10, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "feedbackAmplitude", envelope: "decay 2" },
						{ target: "noteFilterAllFreqs", envelope: "twang 3" },
						{ target: "operatorAmplitude", envelope: "decay 3", index: 3 },
						{ target: "pitchShift", envelope: "tremolo3" },
					],
				},
			},
			{
				name: "MAD",
				generalMidi: false,
				tags: ["fm", "fm6op", "unbox", "novelty"],
				settings: {
					type: "FM6op",
					eqFilter: [],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [],
					effects: ["transition type", "vibrato", "note filter", "bitcrusher"],
					transition: "interrupt",
					clicklessTransition: false,
					vibrato: "custom",
					vibratoDepth: 0.08,
					vibratoDelay: 26,
					vibratoSpeed: 10,
					vibratoType: 0,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [],
					noteSubFilters0: [],
					bitcrusherOctave: 6.5,
					bitcrusherQuantization: 57,
					panDelay: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1←3 2←(4 5 6)",
					feedbackType: "1⟲ 2⟲",
					feedbackAmplitude: 6,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 6, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 3, waveform: "sine", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 12, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			},
			{
				name: "Goofy Chime",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 0.5,
						},
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 420.45, linearGain: 0.3536 },
						{
							type: "peak",
							cutoffHz: 3363.59,
							linearGain: 0.5,
						},
					],
					effects: [
						"transition type",
						"note filter",
						"distortion",
						"chorus",
						"echo",
						"reverb",
					],
					transition: "interrupt",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1.4142 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 11313.71, linearGain: 1.4142 }],
					distortion: 0,
					aliases: false,
					panDelay: 10,
					chorus: 57,
					echoSustain: 57,
					echoDelayBeats: 0.5,
					reverb: 10,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					algorithm: "1 2 3 4",
					feedbackType: "1⟲",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "1×", amplitude: 15, waveform: "sawtooth", pulseWidth: 5 },
						{ frequency: "11×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "2×", amplitude: 15, waveform: "pulse width", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [
						{ target: "noteFilterAllFreqs", envelope: "swell 1" },
						{
							target: "noteFilterAllFreqs",
							envelope: "twang 3",
						},
						{ target: "noteFilterFreq", envelope: "wibble 2", index: 0 },
					],
				},
			},
			{
				name: "RUN",
				generalMidi: false,
				tags: ["spectrum", "unbox", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [{ type: "high-pass", cutoffHz: 707.11, linearGain: 0.7071 }],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [{ type: "high-pass", cutoffHz: 707.11, linearGain: 0.7071 }],
					effects: ["transition type", "note filter", "bitcrusher", "echo", "reverb"],
					transition: "normal",
					clicklessTransition: false,
					noteFilterType: false,
					noteSimpleCut: 10,
					noteSimplePeak: 0,
					noteFilter: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					noteSubFilters0: [{ type: "low-pass", cutoffHz: 2378.41, linearGain: 0.5 }],
					bitcrusherOctave: 2,
					bitcrusherQuantization: 43,
					panDelay: 10,
					echoSustain: 71,
					echoDelayBeats: 2,
					reverb: 68,
					fadeInSeconds: 0,
					fadeOutTicks: -1,
					spectrum: [
						100, 0, 0, 0, 0, 0, 0, 71, 0, 0, 0, 57, 0, 0, 71, 0, 0, 86, 0, 100, 0, 43,
						0, 0, 71, 14, 43, 0, 71, 0,
					],
					unison: "dirty",
					envelopes: [
						{ target: "noteVolume", envelope: "tremolo0" },
						{
							target: "noteFilterFreq",
							envelope: "wibble 3",
							index: 0,
						},
					],
				},
			},
			{
				name: "Silly String",
				generalMidi: false,
				tags: ["fm", "fm4op", "unbox", "novelty"],
				settings: {
					type: "FM",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 500, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.125 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 297.3, linearGain: 0.3536 },
						{ type: "peak", cutoffHz: 2000, linearGain: 0.0884 },
						{ type: "peak", cutoffHz: 500, linearGain: 1.4142 },
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.125 },
					],
					effects: ["chord type", "vibrato", "echo", "reverb"],
					chord: "strum",
					fastTwoNoteArp: false,
					arpeggioSpeed: 12,
					vibrato: "light",
					vibratoDepth: 0.15,
					vibratoDelay: 0,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					echoSustain: 100,
					echoDelayBeats: 1.083,
					reverb: 6,
					fadeInSeconds: 0.075,
					fadeOutTicks: 6,
					algorithm: "(1 2 3)←4",
					feedbackType: "3→4",
					feedbackAmplitude: 0,
					operators: [
						{ frequency: "50×", amplitude: 12, waveform: "ramp", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 13, waveform: "trapezoid", pulseWidth: 5 },
						{ frequency: "0.5×", amplitude: 13, waveform: "triangle", pulseWidth: 5 },
						{ frequency: "4×", amplitude: 1, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
						{ frequency: "1×", amplitude: 0, waveform: "sine", pulseWidth: 5 },
					],
					envelopes: [],
				},
			}, // from the "unbox stuff" folder. silly but enjoyable regardless.
			{
				name: "Goofy Voice",
				generalMidi: false,
				tags: ["spectrum", "unbox", "novelty"],
				settings: {
					type: "spectrum",
					eqFilter: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.5 },
					],
					eqFilterType: false,
					eqSimpleCut: 10,
					eqSimplePeak: 0,
					envelopeSpeed: 12,
					discreteEnvelope: false,
					eqSubFilters0: [
						{ type: "high-pass", cutoffHz: 250, linearGain: 0.1768 },
						{
							type: "peak",
							cutoffHz: 2000,
							linearGain: 1.4142,
						},
						{ type: "peak", cutoffHz: 594.6, linearGain: 0.5 },
					],
					effects: ["vibrato", "reverb"],
					vibrato: "delayed",
					vibratoDepth: 0.3,
					vibratoDelay: 18.5,
					vibratoSpeed: 10,
					vibratoType: 0,
					panDelay: 10,
					reverb: 35,
					fadeInSeconds: 0.0938,
					fadeOutTicks: 0,
					spectrum: [
						100, 0, 29, 0, 14, 0, 29, 86, 0, 43, 43, 86, 43, 0, 100, 0, 86, 0, 57, 43,
						29, 57, 0, 0, 29, 0, 0, 0, 14, 14,
					],
					unison: "dissonant",
					envelopes: [],
				},
			},
		]),
	},
];
